import React, { useEffect, useState } from "react";
import axios from "axios";
import MainLogo from "../../../src/assets/image/main-logo.png";
import { useLocation } from "react-router-dom";
import Footer from "../superAdmin/footer/Footer";
import { useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import Select from "react-select";
import { Spinner, Form, Row, Col, Card, Modal, Button } from "react-bootstrap";
import TokenUndefined from "../Service/TokenUndefined";
import { message, Modal as AntdModal } from "antd";
import FormatChecker from "../Service/FormatChecker";
import moment from "moment";
import { createRazorypayOrder } from "../Service/paymentForExtraMember.service";
import { storage } from "../../utils/auth";
import { FaAngleDoubleLeft } from "react-icons/fa";
import { compressImage } from "../../utils/compressImage";

function VisitorForm({
  formHeader,
  formName,
  editStatus,
  companyType,
  edit_name,
  edit_contact,
  edit_phone,
  edit_email,
  id,
  barcode,
  barcodeId,
  isEditing,
}) {
  // Constants for stay options
  const oneNightOptions = [
    { value: "6th-7th", label: "6-7th of August" },
    { value: "7th-8th", label: "7-8th of August" },
  ];

  const twoNightOptions = [
    { value: "5th-7th", label: "5-7th of August" },
    { value: "6th-8th", label: "6-8th of August" },
  ];

  const travelModes = [
    { value: "Flight", label: "Flight" },
    { value: "Train", label: "Train" },
    { value: "Self", label: "Self" },
  ];

  let editName = edit_name === undefined ? "" : edit_name;
  let editContact = edit_contact === undefined ? "" : edit_contact;
  let editPhone = edit_phone === undefined ? "" : edit_phone;
  let editEmail = edit_email === undefined ? "" : edit_email;

  console.log(
    "sdasdadadadadads0",
    editName,
    editContact,
    editPhone,
    editEmail,
    companyType,
  );
  const navigate = useNavigate();

  let currentLocation = useLocation().pathname;

  const designationArray = ["Owner", "Representative "];
  const visitingAsArray = [
    "Wholesaler",
    "Manufacturer",
    "Retailer",
    "Chain Store   ",
    "Agent/Broker",
  ];
  const [number, setNumber] = useState(editPhone);
  const [visitorName, setVisitorName] = useState(editContact);
  const [designation, setDesignation] = useState("");
  const [visitingCategory, setVisitingCategory] = useState("");
  const [visitingID, setVisitingID] = useState("");
  const [visiting_as, setVisiting_as] = useState("");
  const [yourCompany, setYourCompany] = useState();
  const [comapnyList, setComapnyList] = useState([]);
  const [invitedByCompany, setInvitedByCompany] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState(editEmail);
  const [postalCode, setPostalCode] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [streetAddress, setStreetAddress] = useState("");
  const [gender, setGender] = useState("");
  const [streetAddressTwo, setstreetAddressTwo] = useState("");
  const [country, setCountry] = useState("India");
  const [hearAbout, setHearAbout] = useState("");
  const [photo, setPhoto] = useState();
  const [photoPreview, setPhotoPreview] = useState(null);
  const [idProofFront, setIDProofFront] = useState(null);
  const [idProofFrontPreview, setIDProofFrontPreview] = useState(null);
  const [idProofBack, setIDProofBack] = useState();
  const [idProofBackPreview, setIDProofBackPreview] = useState(null);
  const [invitedCompanyName, setInvitedCompanyName] = useState(editName);
  const [visitingDay, setVisitingDay] = useState("");
  const [reload, setReload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [exhibitorName, setExhibitorName] = useState("");
  const [photoStatus, setPhotoStatus] = useState(false);
  const [idFrontStatus, setIdFrontStatus] = useState(false);
  const [idBackStatus, setIdBackStatus] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [gst_number, setGst_number] = useState("");
  const [showError, setShowError] = useState("");
  const [reloadShow, setReloadShow] = useState(false);
  const [duplicateError, setDuplicateError] = useState(false);
  const [gstValidating, setGstValidating] = useState(false);

  const [currentStep, setCurrentStep] = useState(1);
  const [totalSteps] = useState(3);
  const [arrivalMode, setArrivalMode] = useState("");
  const [stayDuration, setStayDuration] = useState("1");
  const [stayDate, setStayDate] = useState(null);
  const [checkOutDate, setCheckOutDate] = useState(null);
  const [needsCab, setNeedsCab] = useState(false);
  const [visitorData, setVisitorData] = useState(null);
  const [ticketsFor, setTicketsFor] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [preferredTravelTime, setPreferredTravelTime] = useState("");
  const [exhibitorId, setExhibitorId] = useState("");
  const [travelDate, setTravelDate] = useState("");
  const [remarksValue, setRemarksValue] = useState("");
  const [demoGstNumber, setDemoGstNumber] = useState(false);
  const [showExtraOwnerModal, setShowExtraOwnerModal] = useState(false);
  const [isPaymentTaken, setIsPaymentTaken] = useState(false);
  const [extraStaffRegistration, setExtraStaffRegistration] =
    useState("active");
  const [isApproved, setIsApproved] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const resetForm = () => {
    setNumber(editPhone || "");
    setVisitorName(editContact || "");
    setDesignation("");
    setVisitingCategory("");
    setVisitingID("");
    setVisiting_as("");
    setYourCompany(undefined);
    setInvitedByCompany("");
    setCompanyName("");
    setEmail(editEmail || "");
    setGst_number("");
    setPostalCode("");
    setCity("");
    setState("");
    setStreetAddress("");
    setGender("");
    setstreetAddressTwo("");
    setCountry("India");
    setHearAbout("");
    setPhoto(undefined);
    setPhotoPreview(null);
    setIDProofFront(null);
    setIDProofFrontPreview(null);
    setIDProofBack(undefined);
    setIDProofBackPreview(null);
    setInvitedCompanyName(editName || "");
    setVisitingDay("");
    setVisitorData(null);
    setArrivalMode("");
    setTicketsFor("");
    setFrom("");
    setTo("");
    setStayDuration("1");
    setStayDate(null);
    setNeedsCab(false);
    setPreferredTravelTime("");
    setTravelDate("");
    setRemarksValue("");
    setDemoGstNumber(false);
    setIsApproved(false);
    setCurrentStep(1);
    setShowError("");
    setDuplicateError(false);
  };

  useEffect(() => {
    if (isEditing && barcodeId) {
      axios
        .get(
          `${process.env.REACT_APP_API_END_POINT}/get-visitor-by-barcode/${barcodeId}`,
          { headers: { token: storage.get("token") } },
        )
        .then((res) => {
          if (res.data.status) {
            const data = res.data.data;
            if (
              data.approved_status === "true" ||
              data.approved_status === true
            ) {
              setIsApproved(true);
            } else {
              setIsApproved(false);
            }
            setNumber(data.mobile_number || "");
            setVisitorData(data);
            setCurrentStep(1); // Force to step 1 for editing
            setErrorMessage("");
          } else {
            setErrorMessage(
              res.data.message || "Failed to load visitor details.",
            );
          }
        })
        .catch((err) => {
          console.error("Error fetching visitor by barcode", err);
          const msg =
            err.response?.data?.message || "Error loading visitor details.";
          setErrorMessage(msg);
        });
    } else {
      resetForm();
    }
  }, [isEditing, barcodeId]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_END_POINT}/get-registration-visibility`)
      .then((res) => {
        if (res.data && res.data.data) {
          setExtraStaffRegistration(
            res.data.data.extra_staff_registration || "active",
          );
        }
      })
      .catch((err) => {
        console.error("Error fetching registration settings", err);
      });
  }, []);

  const travelTimeOptions = [
    { value: "Before 6 AM", label: "Before 6 AM" },
    { value: "6 AM to 9 AM", label: "6 AM to 9 AM" },
    { value: "9 AM to 12 PM", label: "9 AM to 12 PM" },
    { value: "12 PM to 3 PM", label: "12 PM to 3 PM" },
    { value: "3 PM to 6 PM", label: "3 PM to 6 PM" },
    { value: "After 6 PM", label: "After 6 PM" },
  ];

  const handleMobileNoChange = (e) => {
    const input = e.target.value;
    const numericValue = input.replace(/\D/g, "");
    const user_id = localStorage.getItem("user_id");
    console.log(user_id);
    setNumber(numericValue);

    if (
      numericValue.length === 10 &&
      (formName === "exhibitor_vip" ||
        formName === "exhibitor_owner" ||
        formName === "exhibitor_staff" ||
        formName === "exhibitor_modal")
    ) {
      if (formName === "exhibitor_vip") {
        axios
          .post(
            `${process.env.REACT_APP_API_END_POINT}/check-blacklisted-buyer`,
            {
              mobile_number: numericValue,
            },
          )
          .then((resBlacklist) => {
            if (resBlacklist.data.status) {
              AntdModal.warning({
                title: "Important",
                content:
                  "Please contact the KCE Office for the particular buyer Contact No: 8100370247",
                centered: true,
                okText: "OK",
                okButtonProps: {
                  style: {
                    backgroundColor: "#1890ff",
                    borderColor: "#1890ff",
                    color: "#fff",
                  },
                },
              });
              setNumber("");
              return;
            }
            // Proceed with normal checks
            runMobileValidationAndStatus(numericValue, user_id);
          })
          .catch((err) => {
            console.error("Blacklist check error:", err);
            runMobileValidationAndStatus(numericValue, user_id);
          });
      } else {
        runMobileValidationAndStatus(numericValue, user_id);
      }
    } else {
      setDuplicateError(false);
    }
  };

  const runMobileValidationAndStatus = (numericValue, user_id) => {
    axios
      .get(
        `${process.env.REACT_APP_API_END_POINT}/check-is-number/${numericValue}/${formName}/${user_id}`,
      )
      .then((resData) => {
        setDuplicateError(resData.data.status);
      });
    // step wise form
    if (formName === "exhibitor_vip" && !duplicateError && !isEditing) {
      axios
        .get(
          `${process.env.REACT_APP_API_END_POINT}/check-registration-status/${formName}/${numericValue}/${exhibitorId}`,
        )
        .then((resData) => {
          if (resData.data.status) {
            if (
              resData.data.message === "Visitor is not registered in the system"
            ) {
              axios
                .get(
                  `${process.env.REACT_APP_API_END_POINT}/form-status-exhibitor`,
                  {
                    headers: {
                      token: storage.get("token"),
                    },
                  },
                )
                .then(async (res) => {
                  if (!res.data.vipstatus) {
                    message.error("The limit to add new members has exhausted");

                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  }
                });
            }

            const savedStep = resData.data.currentStep;
            setVisitorData(resData.data.data);
            if (savedStep > totalSteps) {
              if (!isEditing) {
                message.info(
                  "You have already completed the registration process.",
                );
              }
            } else {
              if (!isEditing) {
                setCurrentStep(savedStep);
                if (!resData.data.status) {
                  message.info(`Continuing from step ${savedStep}`);
                }
              }
            }
          } else {
            message.error(resData.data.message);
          }
        })
        .catch((error) => {
          console.error("Error checking registration status:", error);
        });
    }
  };

  const flightOptions = [
    { value: "Agartala", label: "Agartala (IXA)" },
    { value: "Agatti", label: "Agatti (AGX)" },
    { value: "Agra", label: "Agra (AGR)" },
    { value: "Ahmedabad", label: "Ahmedabad (AMD)" },
    { value: "Aizawl", label: "Aizawl (AJL)" },
    { value: "Amritsar", label: "Amritsar (ATQ)" },
    { value: "Aurangabad", label: "Aurangabad (IXU)" },
    { value: "Ayodhya", label: "Ayodhya (AYJ)" },
    { value: "Bagdogra", label: "Bagdogra (IXB)" },
    { value: "Bareilly", label: "Bareilly (BEK)" },
    { value: "Belagavi", label: "Belagavi (IXG)" },
    { value: "Bengaluru", label: "Bengaluru (BLR)" },
    { value: "Bhopal", label: "Bhopal (BHO)" },
    { value: "Bhubaneswar", label: "Bhubaneswar (BBI)" },
    { value: "Bikaner", label: "Bikaner (BKN)" },
    { value: "Chandigarh", label: "Chandigarh (IXC)" },
    { value: "Chennai", label: "Chennai (MAA)" },
    { value: "Coimbatore", label: "Coimbatore (CJB)" },
    { value: "Darbhanga", label: "Darbhanga (DBR)" },
    { value: "Dehradun", label: "Dehradun (DED)" },
    { value: "Delhi", label: "Delhi (DEL)" },
    { value: "Deoghar", label: "Deoghar (DGH)" },
    { value: "Dharamshala", label: "Dharamshala (DHM)" },
    { value: "Dibrugarh", label: "Dibrugarh (DIB)" },
    { value: "Dimapur", label: "Dimapur (DMU)" },
    { value: "Diu", label: "Diu (DIU)" },
    { value: "Durgapur", label: "Durgapur (RDP)" },
    { value: "Gaya", label: "Gaya (GAY)" },
    { value: "Ghaziabad", label: "Ghaziabad (HDO)" },
    { value: "Goa", label: "Goa (GOI)" },
    { value: "Gondia", label: "Gondia (GDB)" },
    { value: "Gorakhpur", label: "Gorakhpur (GOP)" },
    { value: "Guwahati", label: "Guwahati (GAU)" },
    { value: "Gwalior", label: "Gwalior (GWL)" },
    { value: "Hirasar", label: "Hirasar (HSR)" },
    { value: "Hubli", label: "Hubli (HBX)" },
    { value: "Hyderabad", label: "Hyderabad (HYD)" },
    { value: "Imphal", label: "Imphal (IMF)" },
    { value: "Indore", label: "Indore (IDR)" },
    { value: "Itanagar", label: "Itanagar (HGI)" },
    { value: "Jabalpur", label: "Jabalpur (JLR)" },
    { value: "Jagdalpur", label: "Jagdalpur (JGB)" },
    { value: "Jaipur", label: "Jaipur (JAI)" },
    { value: "Jaisalmer", label: "Jaisalmer (JSA)" },
    { value: "Jammu", label: "Jammu (IXJ)" },
    { value: "Jharsuguda", label: "Jharsuguda (JRG)" },
    { value: "Jodhpur", label: "Jodhpur (JDH)" },
    { value: "Jorhat", label: "Jorhat (JRH)" },
    { value: "Kathmandu", label: "Kathmandu (KTM)" },
    { value: "Kadapa", label: "Kadapa (CDP)" },
    { value: "Kannur", label: "Kannur (CNN)" },
    { value: "Kanpur", label: "Kanpur (KNU)" },
    { value: "Khajuraho", label: "Khajuraho (HJR)" },
    { value: "Kochi", label: "Kochi (COK)" },
    { value: "Kolhapur", label: "Kolhapur (KLH)" },
    { value: "Kolkata", label: "Kolkata (CCU)" },
    { value: "Kozhikode", label: "Kozhikode (CCJ)" },
    { value: "Kurnool", label: "Kurnool (KJB)" },
    { value: "Leh", label: "Leh (IXL)" },
    { value: "Lucknow", label: "Lucknow (LKO)" },
    { value: "Madurai", label: "Madurai (IXM)" },
    { value: "Mangaluru", label: "Mangaluru (IXE)" },
    { value: "Mumbai", label: "Mumbai (BOM)" },
    { value: "Mysuru", label: "Mysuru (MYQ)" },
    { value: "Nagpur", label: "Nagpur (NAG)" },
    { value: "Nashik", label: "Nashik (ISK)" },
    { value: "North Goa", label: "North Goa (GOX)" },
    { value: "Pantnagar", label: "Pantnagar (PGH)" },
    { value: "Patna", label: "Patna (PAT)" },
    { value: "Port Blair", label: "Port Blair (IXZ)" },
    { value: "Prayagraj", label: "Prayagraj (IXD)" },
    { value: "Puducherry", label: "Puducherry (PNY)" },
    { value: "Purnea", label: "Purnea (PXN)" },
    { value: "Pune", label: "Pune (PNQ)" },
    { value: "Raipur", label: "Raipur (RPR)" },
    { value: "Rajahmundry", label: "Rajahmundry (RJA)" },
    { value: "Rajkot", label: "Rajkot (RAJ)" },
    { value: "Ranchi", label: "Ranchi (IXR)" },
    { value: "Salem", label: "Salem (SXV)" },
    { value: "Shillong", label: "Shillong (SHL)" },
    { value: "Shirdi", label: "Shirdi (SAG)" },
    { value: "Shivamogga", label: "Shivamogga (RQY)" },
    { value: "Silchar", label: "Silchar (IXS)" },
    { value: "Srinagar", label: "Srinagar (SXR)" },
    { value: "Surat", label: "Surat (STV)" },
    { value: "Thiruvananthapuram", label: "Thiruvananthapuram (TRV)" },
    { value: "Tiruchirappalli", label: "Tiruchirappalli (TRZ)" },
    { value: "Tirupati", label: "Tirupati (TIR)" },
    { value: "Tuticorin", label: "Tuticorin (TCR)" },
    { value: "Udaipur", label: "Udaipur (UDR)" },
    { value: "Vadodara", label: "Vadodara (BDQ)" },
    { value: "Varanasi", label: "Varanasi (VNS)" },
    { value: "Vijayawada", label: "Vijayawada (VGA)" },
    { value: "Visakhapatnam", label: "Visakhapatnam (VTZ)" },
  ];
  const trainOptions = [
    {
      value: "Port Blair", label: "Port Blair"
    },
    {
      value: "Adilabad", label: "Adilabad"
    },
    {
      value: "Anantapur", label: "Anantapur"
    },
    {
      value: "Chittoor", label: "Chittoor"
    },
    {
      value: "Caliut", label: "Caliut"
    },
    {
      value: "East Godavari", label: "East Godavari"
    },
    {
      value: "Guntur", label: "Guntur"
    },
    {
      value: "Hyderabad", label: "Hyderabad"
    },
    {
      value: "Karimnagar", label: "Karimnagar"
    },
    {
      value: "Khammam", label: "Khammam"
    },
    {
      value: "Krishna", label: "Krishna"
    },
    {
      value: "Kurnool", label: "Kurnool"
    },
    {
      value: "Mahbubnagar", label: "Mahbubnagar"
    },
    {
      value: "Medak", label: "Medak"
    },
    {
      value: "Nalgonda", label: "Nalgonda"
    },
    {
      value: "Nellore", label: "Nellore"
    },
    {
      value: "Nizamabad", label: "Nizamabad"
    },
    {
      value: "Prakasam", label: "Prakasam"
    },
    {
      value: "Srikakulam", label: "Srikakulam"
    },
    {
      value: "Visakhapatnam", label: "Visakhapatnam"
    },
    {
      value: "Warangal", label: "Warangal"
    },
    {
      value: "West Godavari", label: "West Godavari"
    },
    {
      value: "Akashiganga", label: "Akashiganga"
    },
    {
      value: "Bhalukpong", label: "Bhalukpong"
    },
    {
      value: "Bhismaknagar", label: "Bhismaknagar"
    },
    {
      value: "Bomdila", label: "Bomdila"
    },
    {
      value: "Itanagar", label: "Itanagar"
    },
    {
      value: "Malinithan", label: "Malinithan"
    },
    {
      value: "Digboi", label: "Digboi"
    },
    {
      value: "Dispur", label: "Dispur"
    },
    {
      value: "Guwahati", label: "Guwahati"
    },
    {
      value: "Haflong", label: "Haflong"
    },
    {
      value: "Hajo", label: "Hajo"
    },
    {
      value: "Majuli", label: "Majuli"
    },
    {
      value: "Tezpur", label: "Tezpur"
    },
    {
      value: "Bhagalpur", label: "Bhagalpur"
    },
    {
      value: "Gaya", label: "Gaya"
    },
    {
      value: "Patna", label: "Patna"
    },
    {
      value: "Chandigarh", label: "Chandigarh"
    },
    {
      value: "Bhilai", label: "Bhilai"
    },
    {
      value: "Bilaspur", label: "Bilaspur"
    },
    {
      value: "Raipur", label: "Raipur"
    },
    {
      value: "Dadra and Nagar Haveli", label: "Dadra and Nagar Haveli"
    },
    {
      value: "Daman", label: "Daman"
    },
    {
      value: "Diu", label: "Diu"
    },
    {
      value: "Goa", label: "Goa"
    },
    {
      value: "Ahmedabad", label: "Ahmedabad"
    },
    {
      value: "Anand", label: "Anand"
    },
    {
      value: "Ankleshwar", label: "Ankleshwar"
    },
    {
      value: "Bharuch", label: "Bharuch"
    },
    {
      value: "Bhavnagar", label: "Bhavnagar"
    },
    {
      value: "Bhuj-Rudramata", label: "Bhuj-Rudramata"
    },
    {
      value: "Gandhinagar", label: "Gandhinagar"
    },
    {
      value: "Jamnagar", label: "Jamnagar"
    },
    {
      value: "Kapadvanj", label: "Kapadvanj"
    },
    {
      value: "Morbi", label: "Morbi"
    },
    {
      value: "Nadiad", label: "Nadiad"
    },
    {
      value: "Navsari", label: "Navsari"
    },
    {
      value: "Porbandar", label: "Porbandar"
    },
    {
      value: "Rajkot", label: "Rajkot"
    },
    {
      value: "Rajpipla", label: "Rajpipla"
    },
    {
      value: "Surat", label: "Surat"
    },
    {
      value: "Surendranagar", label: "Surendranagar"
    },
    {
      value: "Vadodara", label: "Vadodara"
    },
    {
      value: "Valsad", label: "Valsad"
    },
    {
      value: "Ambala", label: "Ambala"
    },
    {
      value: "Bhiwani", label: "Bhiwani"
    },
    {
      value: "Faridabad", label: "Faridabad"
    },
    {
      value: "Fatehabad", label: "Fatehabad"
    },
    {
      value: "Gurgaon", label: "Gurgaon"
    },
    {
      value: "Jhajjar", label: "Jhajjar"
    },
    {
      value: "Jind", label: "Jind"
    },
    {
      value: "Kaithal", label: "Kaithal"
    },
    {
      value: "Karnal", label: "Karnal"
    },
    {
      value: "Kurukshetra", label: "Kurukshetra"
    },
    {
      value: "Mahendragarh", label: "Mahendragarh"
    },
    {
      value: "Panchkula", label: "Panchkula"
    },
    {
      value: "Panipat", label: "Panipat"
    },
    {
      value: "Rewari", label: "Rewari"
    },
    {
      value: "Rohtak", label: "Rohtak"
    },
    {
      value: "Sirsa", label: "Sirsa"
    },
    {
      value: "Sonipat", label: "Sonipat"
    },
    {
      value: "Yamuna Nagar", label: "Yamuna Nagar"
    },
    {
      value: "Dalhousie", label: "Dalhousie"
    },
    {
      value: "Kullu", label: "Kullu"
    },
    {
      value: "Shimla", label: "Shimla"
    },
    {
      value: "Solan", label: "Solan"
    },
    {
      value: "Gulmarg", label: "Gulmarg"
    },
    {
      value: "Ladakh", label: "Ladakh"
    },
    {
      value: "Leh", label: "Leh"
    },
    {
      value: "Pahalgam", label: "Pahalgam"
    },
    {
      value: "Srinagar", label: "Srinagar"
    },
    {
      value: "Adityapur", label: "Adityapur"
    },
    {
      value: "Bokaro", label: "Bokaro"
    },
    {
      value: "Dhanbad", label: "Dhanbad"
    },
    {
      value: "Hazaribagh", label: "Hazaribagh"
    },
    {
      value: "Jamshedpur", label: "Jamshedpur"
    },
    {
      value: "Ranchi", label: "Ranchi"
    },
    {
      value: "Bagalkot", label: "Bagalkot"
    },
    {
      value: "Bangalore", label: "Bangalore"
    },
    {
      value: "Belgaum", label: "Belgaum"
    },
    {
      value: "Bellary", label: "Bellary"
    },
    {
      value: "Bidar", label: "Bidar"
    },
    {
      value: "Bijapur", label: "Bijapur"
    },
    {
      value: "Chamarajanagar", label: "Chamarajanagar"
    },
    {
      value: "Chikmagalur", label: "Chikmagalur"
    },
    {
      value: "Chitradurga", label: "Chitradurga"
    },
    {
      value: "Coorg", label: "Coorg"
    },
    {
      value: "Dakshina Kannada", label: "Dakshina Kannada"
    },
    {
      value: "Davangere", label: "Davangere"
    },
    {
      value: "Gadag", label: "Gadag"
    },
    {
      value: "Gulbarga", label: "Gulbarga"
    },
    {
      value: "Hassan", label: "Hassan"
    },
    {
      value: "Haveri", label: "Haveri"
    },
    {
      value: "Kolar", label: "Kolar"
    },
    {
      value: "Koppal", label: "Koppal"
    },
    {
      value: "Mandya", label: "Mandya"
    },
    {
      value: "Mysore", label: "Mysore"
    },
    {
      value: "Raichur", label: "Raichur"
    },
    {
      value: "Shimoga", label: "Shimoga"
    },
    {
      value: "Tumkur", label: "Tumkur"
    },
    {
      value: "Udupi", label: "Udupi"
    },
    {
      value: "Uttara Kannada", label: "Uttara Kannada"
    },
    {
      value: "Alappuzha", label: "Alappuzha"
    },
    {
      value: "Ernakulam", label: "Ernakulam"
    },
    {
      value: "Idukki", label: "Idukki"
    },
    {
      value: "Kalpetta", label: "Kalpetta"
    },
    {
      value: "Kannur", label: "Kannur"
    },
    {
      value: "Kasaragod", label: "Kasaragod"
    },
    {
      value: "Kollam", label: "Kollam"
    },
    {
      value: "Kottayam", label: "Kottayam"
    },
    {
      value: "Kozhikode", label: "Kozhikode"
    },
    {
      value: "Palakkad", label: "Palakkad"
    },
    {
      value: "Pathanamthitta", label: "Pathanamthitta"
    },
    {
      value: "Lakshadweep", label: "Lakshadweep"
    },
    {
      value: "Anuppur", label: "Anuppur"
    },
    {
      value: "Ashoknagar", label: "Ashoknagar"
    },
    {
      value: "Balaghat", label: "Balaghat"
    },
    {
      value: "Barwani", label: "Barwani"
    },
    {
      value: "Betul", label: "Betul"
    },
    {
      value: "Bhind", label: "Bhind"
    },
    {
      value: "Bhopal", label: "Bhopal"
    },
    {
      value: "Chhindwara", label: "Chhindwara"
    },
    {
      value: "Damoh", label: "Damoh"
    },
    {
      value: "Datia", label: "Datia"
    },
    {
      value: "Dewas", label: "Dewas"
    },
    {
      value: "Dhar", label: "Dhar"
    },
    {
      value: "Dindori", label: "Dindori"
    },
    {
      value: "Gwalior", label: "Gwalior"
    },
    {
      value: "Harda", label: "Harda"
    },
    {
      value: "Hoshangabad", label: "Hoshangabad"
    },
    {
      value: "Indore", label: "Indore"
    },
    {
      value: "Jabalpur", label: "Jabalpur"
    },
    {
      value: "Jhabua", label: "Jhabua"
    },
    {
      value: "Katni", label: "Katni"
    },
    {
      value: "Khandwa", label: "Khandwa"
    },
    {
      value: "Khargone", label: "Khargone"
    },
    {
      value: "Mandla", label: "Mandla"
    },
    {
      value: "Mandsaur", label: "Mandsaur"
    },
    {
      value: "Morena", label: "Morena"
    },
    {
      value: "Narsinghpur", label: "Narsinghpur"
    },
    {
      value: "Neemuch", label: "Neemuch"
    },
    {
      value: "Panna", label: "Panna"
    },
    {
      value: "Raisen", label: "Raisen"
    },
    {
      value: "Rajgarh", label: "Rajgarh"
    },
    {
      value: "Ratlam", label: "Ratlam"
    },
    {
      value: "Rewa", label: "Rewa"
    },
    {
      value: "Sagar", label: "Sagar"
    },
    {
      value: "Satna", label: "Satna"
    },
    {
      value: "Sehore", label: "Sehore"
    },
    {
      value: "Seoni", label: "Seoni"
    },
    {
      value: "Shahdol", label: "Shahdol"
    },
    {
      value: "Shajapur", label: "Shajapur"
    },
    {
      value: "Sheopur", label: "Sheopur"
    },
    {
      value: "Shivpuri", label: "Shivpuri"
    },
    {
      value: "Sidhi", label: "Sidhi"
    },
    {
      value: "Tikamgarh", label: "Tikamgarh"
    },
    {
      value: "Ujjain", label: "Ujjain"
    },
    {
      value: "Umaria", label: "Umaria"
    },
    {
      value: "Vidisha", label: "Vidisha"
    },
    {
      value: "Ahmednagar", label: "Ahmednagar"
    },
    {
      value: "Akola", label: "Akola"
    },
    {
      value: "Amravati", label: "Amravati"
    },
    {
      value: "Aurangabad", label: "Aurangabad"
    },
    {
      value: "Dhule", label: "Dhule"
    },
    {
      value: "Jalgaon", label: "Jalgaon"
    },
    {
      value: "Kolhapur", label: "Kolhapur"
    },
    {
      value: "Mahabaleshwar", label: "Mahabaleshwar"
    },
    {
      value: "Mumbai", label: "Mumbai"
    },
    {
      value: "Nagpur", label: "Nagpur"
    },
    {
      value: "Nanded", label: "Nanded"
    },
    {
      value: "Nashik", label: "Nashik"
    },
    {
      value: "Pune", label: "Pune"
    },
    {
      value: "Sangli", label: "Sangli"
    },
    {
      value: "Satara", label: "Satara"
    },
    {
      value: "Solapur", label: "Solapur"
    },
    {
      value: "Thane", label: "Thane"
    },
    {
      value: "Wardha", label: "Wardha"
    },
    {
      value: "Bishnupur", label: "Bishnupur"
    },
    {
      value: "Chandel", label: "Chandel"
    },
    {
      value: "Churachandpur", label: "Churachandpur"
    },
    {
      value: "Imphal", label: "Imphal"
    },
    {
      value: "Manipur", label: "Manipur"
    },
    {
      value: "Senapati", label: "Senapati"
    },
    {
      value: "Tamenglong", label: "Tamenglong"
    },
    {
      value: "Ukhrul", label: "Ukhrul"
    },
    {
      value: "East Khasi Hills", label: "East Khasi Hills"
    },
    {
      value: "Jaintia Hills", label: "Jaintia Hills"
    },
    {
      value: "Ri Bhoi", label: "Ri Bhoi"
    },
    {
      value: "South Garo Hills", label: "South Garo Hills"
    },
    {
      value: "West Garo Hills", label: "West Garo Hills"
    },
    {
      value: "West Khasi Hills", label: "West Khasi Hills"
    },
    {
      value: "Aizawl", label: "Aizawl"
    },
    {
      value: "Kolasib", label: "Kolasib"
    },
    {
      value: "Lunglei", label: "Lunglei"
    },
    {
      value: "Mamit", label: "Mamit"
    },
    {
      value: "Mizoram", label: "Mizoram"
    },
    {
      value: "Vairengte", label: "Vairengte"
    },
    {
      value: "Dimapur", label: "Dimapur"
    },
    {
      value: "Kohima", label: "Kohima"
    },
    {
      value: "Mokokchung", label: "Mokokchung"
    },
    {
      value: "Mon", label: "Mon"
    },
    {
      value: "Phek", label: "Phek"
    },
    {
      value: "Tuensang", label: "Tuensang"
    },
    {
      value: "Wokha", label: "Wokha"
    },
    {
      value: "Zunheboto", label: "Zunheboto"
    },
    {
      value: "Balasore", label: "Balasore"
    },
    {
      value: "Berhampur", label: "Berhampur"
    },
    {
      value: "Bhubaneswar", label: "Bhubaneswar"
    },
    {
      value: "Cuttack", label: "Cuttack"
    },
    {
      value: "Rourkela", label: "Rourkela"
    },
    {
      value: "Sambalpur", label: "Sambalpur"
    },
    {
      value: "Pondicherry", label: "Pondicherry"
    },
    {
      value: "Amritsar", label: "Amritsar"
    },
    {
      value: "Anandpur Sahib", label: "Anandpur Sahib"
    },
    {
      value: "Faridkot", label: "Faridkot"
    },
    {
      value: "Gurdaspur", label: "Gurdaspur"
    },
    {
      value: "Hoshiarpur", label: "Hoshiarpur"
    },
    {
      value: "Jalandhar", label: "Jalandhar"
    },
    {
      value: "Kapurthala", label: "Kapurthala"
    },
    {
      value: "Ludhiana", label: "Ludhiana"
    },
    {
      value: "Moga", label: "Moga"
    },
    {
      value: "Nangal", label: "Nangal"
    },
    {
      value: "Pathankot", label: "Pathankot"
    },
    {
      value: "Patiala", label: "Patiala"
    },
    {
      value: "Sanghol", label: "Sanghol"
    },
    {
      value: "Sangrur", label: "Sangrur"
    },
    {
      value: "Ajmer", label: "Ajmer"
    },
    {
      value: "Alwar", label: "Alwar"
    },
    {
      value: "Bhilwara", label: "Bhilwara"
    },
    {
      value: "Bikaner", label: "Bikaner"
    },
    {
      value: "Jaipur", label: "Jaipur"
    },
    {
      value: "Jodhpur", label: "Jodhpur"
    },
    {
      value: "Kota", label: "Kota"
    },
    {
      value: "Udaipur", label: "Udaipur"
    },
    {
      value: "Gangtok", label: "Gangtok"
    },
    {
      value: "Gezing", label: "Gezing"
    },
    {
      value: "Jorethang", label: "Jorethang"
    },
    {
      value: "Mangan", label: "Mangan"
    },
    {
      value: "Pelling", label: "Pelling"
    },
    {
      value: "Singtam", label: "Singtam"
    },
    {
      value: "Yuksam", label: "Yuksam"
    },
    {
      value: "Chennai", label: "Chennai"
    },
    {
      value: "Coimbatore", label: "Coimbatore"
    },
    {
      value: "Cuddalore", label: "Cuddalore"
    },
    {
      value: "Dharmapuri", label: "Dharmapuri"
    },
    {
      value: "Dindigul", label: "Dindigul"
    },
    {
      value: "Erode", label: "Erode"
    },
    {
      value: "Kanchipuram", label: "Kanchipuram"
    },
    {
      value: "Kanyakumari", label: "Kanyakumari"
    },
    {
      value: "Karur", label: "Karur"
    },
    {
      value: "Krishnagiri", label: "Krishnagiri"
    },
    {
      value: "Madurai", label: "Madurai"
    },
    {
      value: "Nagapattinam", label: "Nagapattinam"
    },
    {
      value: "Namakkal", label: "Namakkal"
    },
    {
      value: "Neyveli", label: "Neyveli"
    },
    {
      value: "Perambalur", label: "Perambalur"
    },
    {
      value: "Pudukkottai", label: "Pudukkottai"
    },
    {
      value: "Ramanathapuram", label: "Ramanathapuram"
    },
    {
      value: "Salem", label: "Salem"
    },
    {
      value: "Sivaganga", label: "Sivaganga"
    },
    {
      value: "Thanjavur", label: "Thanjavur"
    },
    {
      value: "The Nilgiris", label: "The Nilgiris"
    },
    {
      value: "Theni", label: "Theni"
    },
    {
      value: "Thoothukudi", label: "Thoothukudi"
    },
    {
      value: "Tiruchirappalli", label: "Tiruchirappalli"
    },
    {
      value: "Tirunelveli", label: "Tirunelveli"
    },
    {
      value: "Tiruvallur", label: "Tiruvallur"
    },
    {
      value: "Tiruvannamalai", label: "Tiruvannamalai"
    },
    {
      value: "Vellore", label: "Vellore"
    },
    {
      value: "Viluppuram", label: "Viluppuram"
    },
    {
      value: "Virudhunagar", label: "Virudhunagar"
    },
    {
      value: "Agartala", label: "Agartala"
    },
    {
      value: "Agra", label: "Agra"
    },
    {
      value: "Aligarh", label: "Aligarh"
    },
    {
      value: "Allahabad", label: "Allahabad"
    },
    {
      value: "Ayodhya", label: "Ayodhya"
    },
    {
      value: "Deoband", label: "Deoband"
    },
    {
      value: "Etawah", label: "Etawah"
    },
    {
      value: "Kanpur", label: "Kanpur"
    },
    {
      value: "Lucknow", label: "Lucknow"
    },
    {
      value: "Mirzapur", label: "Mirzapur"
    },
    {
      value: "Almora", label: "Almora"
    },
    {
      value: "Bageshwar", label: "Bageshwar"
    },
    {
      value: "Chamoli", label: "Chamoli"
    },
    {
      value: "Champawat", label: "Champawat"
    },
    {
      value: "Dehradun", label: "Dehradun"
    },
    {
      value: "Haridwar", label: "Haridwar"
    },
    {
      value: "Nainital", label: "Nainital"
    },
    {
      value: "Pauri", label: "Pauri"
    },
    {
      value: "Pithoragarh", label: "Pithoragarh"
    },
    {
      value: "Rudraprayag", label: "Rudraprayag"
    },
    {
      value: "Tehri", label: "Tehri"
    },
    {
      value: "Udham Singh Nagar", label: "Udham Singh Nagar"
    },
    {
      value: "Uttarkashi", label: "Uttarkashi"
    },
    {
      value: "Darjeeling", label: "Darjeeling"
    },
    {
      value: "Durgapur", label: "Durgapur"
    },
    {
      value: "Kharagpur", label: "Kharagpur"
    },
    {
      value: "Kolkata", label: "Kolkata"
    },
    {
      value: "Siliguri", label: "Siliguri"
    },
    {
      value: "Secunderabad", label: "Secunderabad"
    },
    {
      value: "Vijayawada", label: "Vijayawada"
    },
    {
      value: "Jammu", label: "Jammu"
    },
    {
      value: "Mangalore", label: "Mangalore"
    },
    {
      value: "Hubli", label: "Hubli"
    },
    {
      value: "Kochi", label: "Kochi"
    },
    {
      value: "Thiruvananthapuram", label: "Thiruvananthapuram"
    },
    {
      value: "Trivandrum", label: "Trivandrum"
    },
    {
      value: "Noida", label: "Noida"
    },
    {
      value: "Ghaziabad", label: "Ghaziabad"
    },
    {
      value: "Varanasi", label: "Varanasi"
    },
    {
      value: "Tinsukia", label: "Tinsukia"
    },
    {
      value: "Panaji", label: "Panaji"
    },
    {
      value: "Gandhidham", label: "Gandhidham"
    },
    {
      value: "Mandi", label: "Mandi"
    },
    {
      value: "Mohali", label: "Mohali"
    },
    {
      value: "Kamrup", label: "Kamrup"
    },
    {
      value: "Nagaon", label: "Nagaon"
    },
    {
      value: "Jorhat", label: "Jorhat"
    },
    {
      value: "Dibrugarh", label: "Dibrugarh"
    },
    {
      value: "Silchar", label: "Silchar"
    },
    {
      value: "Jagdalpur", label: "Jagdalpur"
    },
    {
      value: "Korba", label: "Korba"
    },
    {
      value: "Mehsana", label: "Mehsana"
    },
    {
      value: "Kangra", label: "Kangra"
    },
    {
      value: "Thrissur", label: "Thrissur"
    },
    {
      value: "Chandrapur", label: "Chandrapur"
    },
    {
      value: "Shillong", label: "Shillong"
    },
    {
      value: "Khanna", label: "Khanna"
    },
    {
      value: "East Sikkim", label: "East Sikkim"
    },
    {
      value: "Kunjaban", label: "Kunjaban"
    },
    {
      value: "Meerut", label: "Meerut"
    },
    {
      value: "Gorakhpur", label: "Gorakhpur"
    },
    {
      value: "Jhansi", label: "Jhansi"
    },
    {
      value: "Roorkee", label: "Roorkee"
    },
    {
      value: "Haldwani", label: "Haldwani"
    },
    {
      value: "Asansol", label: "Asansol"
    },
    {
      value: "Maldah", label: "Maldah"
    },
    {
      value: "Vasco Da Gama", label: "Vasco Da Gama"
    },
    {
      value: "Vapi", label: "Vapi"
    },
    {
      value: "Perinthalmanna", label: "Perinthalmanna"
    },
    {
      value: "Shivali", label: "Shivali"
    },
    {
      value: "Rajahmundry", label: "Rajahmundry"
    },
    {
      value: "Durg", label: "Durg"
    },
    {
      value: "Junagadh", label: "Junagadh"
    },
    {
      value: "Himatnagar", label: "Himatnagar"
    },
    {
      value: "Hospet", label: "Hospet"
    },
    {
      value: "Pimpri", label: "Pimpri"
    },
    {
      value: "Faizabad", label: "Faizabad"
    },
    {
      value: "Nicobar Islands", label: "Nicobar Islands"
    },
    {
      value: "Tirupati", label: "Tirupati"
    },
    {
      value: "Bongaigaon", label: "Bongaigaon"
    },
    {
      value: "Golaghat", label: "Golaghat"
    },
    {
      value: "Muzaffarpur", label: "Muzaffarpur"
    },
    {
      value: "Palanpur", label: "Palanpur"
    },
    {
      value: "Nagrota", label: "Nagrota"
    },
    {
      value: "Udhampur", label: "Udhampur"
    },
    {
      value: "Gonikoppal", label: "Gonikoppal"
    },
    {
      value: "Murudeshwara", label: "Murudeshwara"
    },
    {
      value: "Latur", label: "Latur"
    },
    {
      value: "Ratnagiri", label: "Ratnagiri"
    },
    {
      value: "Angul", label: "Angul"
    },
    {
      value: "Abohar", label: "Abohar"
    },
    {
      value: "Mandi Gobindgarh", label: "Mandi Gobindgarh"
    },
    {
      value: "Nawanshahr", label: "Nawanshahr"
    },
    {
      value: "Rupnagar", label: "Rupnagar"
    },
    {
      value: "Rudrapur", label: "Rudrapur"
    },
    {
      value: "Pali", label: "Pali"
    },
    {
      value: "Sikar", label: "Sikar"
    },
    {
      value: "Nagercoil", label: "Nagercoil"
    },
    {
      value: "Sivakasi", label: "Sivakasi"
    },
    {
      value: "Tiruppur", label: "Tiruppur"
    },
    {
      value: "Azamgarh", label: "Azamgarh"
    },
    {
      value: "Bareilly", label: "Bareilly"
    },
    {
      value: "Greater Noida", label: "Greater Noida"
    },
    {
      value: "Mathura", label: "Mathura"
    },
    {
      value: "Moradabad", label: "Moradabad"
    },
    {
      value: "Muzaffarnagar", label: "Muzaffarnagar"
    },
    {
      value: "Bardhaman", label: "Bardhaman"
    },
    {
      value: "Howrah", label: "Howrah"
    },
    {
      value: "Guna", label: "Guna"
    },
    {
      value: "Basti", label: "Basti"
    },
    {
      value: "Bargarh", label: "Bargarh"
    },
    {
      value: "Bundi", label: "Bundi"
    },
    {
      value: "Bijnor", label: "Bijnor"
    },
    {
      value: "Dabra", label: "Dabra"
    },
    {
      value: "Deoria", label: "Deoria"
    },
    {
      value: "Hanumangarh", label: "Hanumangarh"
    },
    {
      value: "Kayamkulam", label: "Kayamkulam"
    },
    {
      value: "Silvassa", label: "Silvassa"
    },
    {
      value: "Dumka", label: "Dumka"
    },
    {
      value: "Hooghly", label: "Hooghly"
    },
    {
      value: "Jharsuguda", label: "Jharsuguda"
    },
    {
      value: "Shahjahanpur", label: "Shahjahanpur"
    },
    {
      value: "Surguja", label: "Surguja"
    },
    {
      value: "Uttar Dinajpur", label: "Uttar Dinajpur"
    },
    {
      value: "Zirakpur", label: "Zirakpur"
    },
    {
      value: "Yavatmal", label: "Yavatmal"
    },
    {
      value: "Vaijnath", label: "Vaijnath"
    },
    {
      value: "Nadia", label: "Nadia"
    },
    {
      value: "Nagaur", label: "Nagaur"
    },
    {
      value: "Sundergarh", label: "Sundergarh"
    },
    {
      value: "Pratapgarh", label: "Pratapgarh"
    },
    {
      value: "Hingoli", label: "Hingoli"
    },
    {
      value: "Godhra", label: "Godhra"
    },
    {
      value: "Dakshin Dinajpur", label: "Dakshin Dinajpur"
    },
    {
      value: "Bhuj", label: "Bhuj"
    },
    {
      value: "Murshidabad", label: "Murshidabad"
    },
    {
      value: "Muvattupuzha", label: "Muvattupuzha"
    },
    {
      value: "Navi Mumbai", label: "Navi Mumbai"
    },
    {
      value: "Banswara", label: "Banswara"
    },
    {
      value: "Chittorgarh", label: "Chittorgarh"
    },
    {
      value: "Saharanpur (UP)", label: "Saharanpur (UP)"
    },
    {
      value: "Srinagar Gpo", label: "Srinagar Gpo"
    },
    {
      value: "Uthangudi", label: "Uthangudi"
    },
    {
      value: "Jeypore", label: "Jeypore"
    },
    {
      value: "Jorabat", label: "Jorabat"
    },
    {
      value: "Mayurbhanj", label: "Mayurbhanj"
    },
    {
      value: "Delhi", label: "Delhi"
    },
    {
      value: "Bokakhat", label: "Bokakhat"
    },
    {
      value: "Cooch Behar", label: "Cooch Behar"
    },
    {
      value: "Paschim Medinipur", label: "Paschim Medinipur"
    },
    {
      value: "Aluva", label: "Aluva"
    },
    {
      value: "Hosur", label: "Hosur"
    },
    {
      value: "Bhimavaram", label: "Bhimavaram"
    },
    {
      value: "North lakhimpur", label: "North lakhimpur"
    },
    {
      value: "Begusarai", label: "Begusarai"
    },
    {
      value: "Ambikapur", label: "Ambikapur"
    },
    {
      value: "Baramati", label: "Baramati"
    },
    {
      value: "Panvel", label: "Panvel"
    },
    {
      value: "Bharatpur", label: "Bharatpur"
    },
    {
      value: "Rajsamand", label: "Rajsamand"
    },
    {
      value: "Sahibabad", label: "Sahibabad"
    },
    {
      value: "Ramagundam", label: "Ramagundam"
    },
    {
      value: "Shahbad", label: "Shahbad"
    },
    {
      value: "Narwana", label: "Narwana"
    },
    {
      value: "Urmar Tanda", label: "Urmar Tanda"
    },
    {
      value: "Barnala", label: "Barnala"
    },
    {
      value: "Nakodar", label: "Nakodar"
    },
    {
      value: "Amb", label: "Amb"
    },
    {
      value: "Churu", label: "Churu"
    },
    {
      value: "Burhanpur", label: "Burhanpur"
    },
    {
      value: "Attingal", label: "Attingal"
    },
    {
      value: "Barrackpore", label: "Barrackpore"
    },
    {
      value: "Krishnanagar", label: "Krishnanagar"
    },
    {
      value: "Renukoot", label: "Renukoot"
    },
    {
      value: "Sultanpur", label: "Sultanpur"
    },
    {
      value: "Dhaleshwar", label: "Dhaleshwar"
    },
    {
      value: "Pattukkottai", label: "Pattukkottai"
    },
    {
      value: "Bodh gaya", label: "Bodh gaya"
    },
    {
      value: "Damtal", label: "Damtal"
    },
    {
      value: "Ulhasnagar", label: "Ulhasnagar"
    },
    {
      value: "Arrah", label: "Arrah"
    },
    {
      value: "Bastar", label: "Bastar"
    },
    {
      value: "Medininagar", label: "Medininagar"
    },
    {
      value: "Gossaigaon", label: "Gossaigaon"
    },
    {
      value: "Jaunpur", label: "Jaunpur"
    },
    {
      value: "Motihari", label: "Motihari"
    },
    {
      value: "Narnaul", label: "Narnaul"
    },
    {
      value: "Nawada", label: "Nawada"
    },
    {
      value: "Ongole", label: "Ongole"
    },
    {
      value: "Purnia", label: "Purnia"
    },
    {
      value: "Siwan", label: "Siwan"
    },
    {
      value: "Naharlagun", label: "Naharlagun"
    },
    {
      value: "Nirjuli", label: "Nirjuli"
    },
    {
      value: "Duliajan", label: "Duliajan"
    },
    {
      value: "Kalyan", label: "Kalyan"
    },
    {
      value: "Verna", label: "Verna"
    },
    {
      value: "Mahe", label: "Mahe"
    },
    {
      value: "Punjagutta", label: "Punjagutta"
    },
    {
      value: "Karaikal", label: "Karaikal"
    },
    {
      value: "Pimpri chinchwad", label: "Pimpri chinchwad"
    },
    {
      value: "Vashi", label: "Vashi"
    },
    {
      value: "Rajnagar", label: "Rajnagar"
    },
    {
      value: "Bardoli", label: "Bardoli"
    },
    {
      value: "Tura", label: "Tura"
    },
    {
      value: "Beed", label: "Beed"
    },
    {
      value: "Palwal", label: "Palwal"
    },
    {
      value: "Robertsganj", label: "Robertsganj"
    },
    {
      value: "Jhunjhunu", label: "Jhunjhunu"
    },
    {
      value: "Darbhanga", label: "Darbhanga"
    },
    {
      value: "Bhiwadi", label: "Bhiwadi"
    },
    {
      value: "Vasai", label: "Vasai"
    },
    {
      value: "Sangamner", label: "Sangamner"
    },
    {
      value: "Rajpura", label: "Rajpura"
    },
    {
      value: "Pollachi", label: "Pollachi"
    },
    {
      value: "Ramgarh", label: "Ramgarh"
    },
    {
      value: "Kakinada", label: "Kakinada"
    },
    {
      value: "Thiruvalla", label: "Thiruvalla"
    },
    {
      value: "Manesar", label: "Manesar"
    },
    {
      value: "Kozhencherry", label: "Kozhencherry"
    },
    {
      value: "Changanassery", label: "Changanassery"
    },
    {
      value: "Pala", label: "Pala"
    },
    {
      value: "Thalayolaparambu", label: "Thalayolaparambu"
    },
    {
      value: "Cherthala", label: "Cherthala"
    },
    {
      value: "Kattappana", label: "Kattappana"
    },
    {
      value: "Thodupuzha", label: "Thodupuzha"
    },
    {
      value: "Bahadurgarh", label: "Bahadurgarh"
    },
    {
      value: "Ooty", label: "Ooty"
    },
    {
      value: "Wayanad", label: "Wayanad"
    },
    {
      value: "Waidhan", label: "Waidhan"
    },
    {
      value: "Dasuya", label: "Dasuya"
    },
    {
      value: "Barpeta", label: "Barpeta"
    },
    {
      value: "Jagiroad", label: "Jagiroad"
    },
    {
      value: "Pakur", label: "Pakur"
    },
    {
      value: "Sasaram", label: "Sasaram"
    },
    {
      value: "Angamaly", label: "Angamaly"
    },
    {
      value: "Jaigaon", label: "Jaigaon"
    },
    {
      value: "Mapusa", label: "Mapusa"
    },
    {
      value: "Deoghar", label: "Deoghar"
    },
    {
      value: "Nuvem", label: "Nuvem"
    },
    {
      value: "Karunagappally", label: "Karunagappally"
    },
    {
      value: "Tirur", label: "Tirur"
    },
    {
      value: "Porvorim", label: "Porvorim"
    },
    {
      value: "Hardoi", label: "Hardoi"
    },
    {
      value: "Kavaratti", label: "Kavaratti"
    },
    {
      value: "Panagarh", label: "Panagarh"
    },
    {
      value: "Anantnag", label: "Anantnag"
    },
    {
      value: "Kashipur", label: "Kashipur"
    },
    {
      value: "Dhubri", label: "Dhubri"
    },
    {
      value: "Koraput", label: "Koraput"
    },
    {
      value: "Dhamtari", label: "Dhamtari"
    },
    {
      value: "Karikkad", label: "Karikkad"
    },
    {
      value: "Unjha", label: "Unjha"
    },
    {
      value: "Gondia", label: "Gondia"
    },
    {
      value: "Nandurbar", label: "Nandurbar"
    },
    {
      value: "Sasthamkotta", label: "Sasthamkotta"
    },
    {
      value: "Sawai madhopur", label: "Sawai madhopur"
    },
    {
      value: "Kumbakonam", label: "Kumbakonam"
    },
    {
      value: "Hoskote", label: "Hoskote"
    },
    {
      value: "Dahegam", label: "Dahegam"
    },
    {
      value: "Payyanur", label: "Payyanur"
    },
    {
      value: "Chaksu", label: "Chaksu"
    },
    {
      value: "Dahod", label: "Dahod"
    },
    {
      value: "Kottarakkara", label: "Kottarakkara"
    },
    {
      value: "Gopeshwar", label: "Gopeshwar"
    },
    {
      value: "Bulandshahr", label: "Bulandshahr"
    },
    {
      value: "Chirala", label: "Chirala"
    },
    {
      value: "Chattarpur", label: "Chattarpur"
    },
    {
      value: "Mainpuri", label: "Mainpuri"
    },
    {
      value: "Kalka", label: "Kalka"
    },
    {
      value: "Punalur", label: "Punalur"
    },
    {
      value: "Balotra", label: "Balotra"
    },
    {
      value: "Kavathe-Mahankal", label: "Kavathe-Mahankal"
    },
    {
      value: "Bhandara", label: "Bhandara"
    },
    {
      value: "Ranni", label: "Ranni"
    },
    {
      value: "Tonk", label: "Tonk"
    },
    {
      value: "Anekal", label: "Anekal"
    },
    {
      value: "Pulwama", label: "Pulwama"
    },
    {
      value: "Cherpulassery", label: "Cherpulassery"
    },
    {
      value: "Lohardaga", label: "Lohardaga"
    },
    {
      value: "Dehra gopipur", label: "Dehra gopipur"
    },
    {
      value: "Phagwara", label: "Phagwara"
    },
    {
      value: "Moodabidri", label: "Moodabidri"
    },
    {
      value: "Valvada", label: "Valvada"
    },
    {
      value: "Osmanabad", label: "Osmanabad"
    },
    {
      value: "Raiganj", label: "Raiganj"
    },
    {
      value: "Hathras", label: "Hathras"
    },
    {
      value: "Red hills", label: "Red hills"
    },
    {
      value: "Gonda", label: "Gonda"
    },
    {
      value: "Suratgarh", label: "Suratgarh"
    },
    {
      value: "Raigarh", label: "Raigarh"
    },
    {
      value: "Triprayar", label: "Triprayar"
    },
    {
      value: "Mavelikara", label: "Mavelikara"
    },
    {
      value: "Kaipamangalam", label: "Kaipamangalam"
    },
    {
      value: "Moosapet", label: "Moosapet"
    },
    {
      value: "Thiruvarur", label: "Thiruvarur"
    },
    {
      value: "Rahata", label: "Rahata"
    },
    {
      value: "Miraj", label: "Miraj"
    },
    {
      value: "Godda", label: "Godda"
    },
    {
      value: "Gudivada", label: "Gudivada"
    },
    {
      value: "Nuzvid", label: "Nuzvid"
    },
    {
      value: "Ballabhgarh", label: "Ballabhgarh"
    },
    {
      value: "Bhachau", label: "Bhachau"
    },
    {
      value: "Gharaunda", label: "Gharaunda"
    },
    {
      value: "Chiplun", label: "Chiplun"
    },
    {
      value: "Jalna", label: "Jalna"
    },
    {
      value: "Taliparamba", label: "Taliparamba"
    },
    {
      value: "Kheralu", label: "Kheralu"
    },
    {
      value: "Baran", label: "Baran"
    },
    {
      value: "Boisar", label: "Boisar"
    },
    {
      value: "Dombivli", label: "Dombivli"
    },
    {
      value: "Chamba", label: "Chamba"
    },
    {
      value: "Tripunithura", label: "Tripunithura"
    },
    {
      value: "Visnagar", label: "Visnagar"
    },
    {
      value: "Belthangady", label: "Belthangady"
    },
    {
      value: "Ranbir Singh Pura", label: "Ranbir Singh Pura"
    },
    {
      value: "Bolangir", label: "Bolangir"
    },
    {
      value: "Rangat", label: "Rangat"
    },
    {
      value: "Akbarpur", label: "Akbarpur"
    },
    {
      value: "Surathkal", label: "Surathkal"
    },
    {
      value: "Baramulla", label: "Baramulla"
    },
    {
      value: "Jagtial", label: "Jagtial"
    },
    {
      value: "Pattambi", label: "Pattambi"
    },
    {
      value: "Baripada", label: "Baripada"
    },
    {
      value: "Karkala", label: "Karkala"
    },
    {
      value: "Unnao", label: "Unnao"
    },
    {
      value: "Banga", label: "Banga"
    },
    {
      value: "Jajpur", label: "Jajpur"
    },
    {
      value: "Naraingarh", label: "Naraingarh"
    },
    {
      value: "Duliajan", label: "Duliajan"
    },
    {
      value: "Akhnoor", label: "Akhnoor"
    },
    {
      value: "Baharampur", label: "Baharampur"
    },
    {
      value: "Zira", label: "Zira"
    },
    {
      value: "Mettupalayam", label: "Mettupalayam"
    },
    {
      value: "Radaur", label: "Radaur"
    },
    {
      value: "Modasa", label: "Modasa"
    },
    {
      value: "Dholka", label: "Dholka"
    },
    {
      value: "Kanhangad", label: "Kanhangad"
    },
    {
      value: "Baraut", label: "Baraut"
    },
    {
      value: "Anpara", label: "Anpara"
    },
    {
      value: "Sinnar", label: "Sinnar"
    },
    {
      value: "Sohna", label: "Sohna"
    },
    {
      value: "Gadhinglaj", label: "Gadhinglaj"
    },
    {
      value: "Eluru", label: "Eluru"
    },
    {
      value: "Dhenkanal", label: "Dhenkanal"
    },
    {
      value: "Tanda", label: "Tanda"
    },
    {
      value: "Baloda Bazar", label: "Baloda Bazar"
    },
    {
      value: "Rajim", label: "Rajim"
    },
    {
      value: "Contai", label: "Contai"
    },
    {
      value: "Singrauli", label: "Singrauli"
    },
    {
      value: "Orai", label: "Orai"
    },
    {
      value: "Jagraon", label: "Jagraon"
    },
    {
      value: "Nilambur", label: "Nilambur"
    },
    {
      value: "Hajipur", label: "Hajipur"
    },
    {
      value: "Washim", label: "Washim"
    },
    {
      value: "Rajnandgaon", label: "Rajnandgaon"
    },
    {
      value: "Dharmanagar", label: "Dharmanagar"
    },
    {
      value: "Neyyattinkara", label: "Neyyattinkara"
    },
    {
      value: "Shahpura", label: "Shahpura"
    },
    {
      value: "Kodungallur", label: "Kodungallur"
    },
    {
      value: "Patan", label: "Patan"
    },
    {
      value: "Vijapur", label: "Vijapur"
    },
    {
      value: "Paonta sahib", label: "Paonta sahib"
    },
    {
      value: "Adoor", label: "Adoor"
    },
    {
      value: "Gohana", label: "Gohana"
    },
    {
      value: "Mahasamund", label: "Mahasamund"
    },
    {
      value: "Machhiwara", label: "Machhiwara"
    },
    {
      value: "Cheeka", label: "Cheeka"
    },
    {
      value: "Kekri", label: "Kekri"
    },
    {
      value: "Ramanagara", label: "Ramanagara"
    },
    {
      value: "Wagholi", label: "Wagholi"
    },
    {
      value: "Barmer", label: "Barmer"
    },
    {
      value: "Daltongang", label: "Daltongang"
    },
    {
      value: "Fazilka", label: "Fazilka"
    },
    {
      value: "Mulki", label: "Mulki"
    },
    {
      value: "Danapur", label: "Danapur"
    },
    {
      value: "Ballia", label: "Ballia"
    },
    {
      value: "Garhshanker", label: "Garhshanker"
    },
    {
      value: "Kundli", label: "Kundli"
    },
    {
      value: "Kengeri", label: "Kengeri"
    },
    {
      value: "Dungarpur", label: "Dungarpur"
    },
    {
      value: "Sirohi", label: "Sirohi"
    },
    {
      value: "Nayagarh", label: "Nayagarh"
    },
    {
      value: "Kudal", label: "Kudal"
    },
    {
      value: "Irinjalakuda", label: "Irinjalakuda"
    },
    {
      value: "Dera Bassi", label: "Dera Bassi"
    },
    {
      value: "Kalamassery", label: "Kalamassery"
    },
    {
      value: "Jaggaiahpeta", label: "Jaggaiahpeta"
    },
    {
      value: "Nilamel", label: "Nilamel"
    },
    {
      value: "Talwara", label: "Talwara"
    },
    {
      value: "Mailatti", label: "Mailatti"
    },
    {
      value: "Santrampur", label: "Santrampur"
    },
    {
      value: "Akluj", label: "Akluj"
    },
    {
      value: "Gobichettipalayam", label: "Gobichettipalayam"
    },
    {
      value: "Kharar", label: "Kharar"
    },
    {
      value: "Samalkha", label: "Samalkha"
    },
    {
      value: "Merta city", label: "Merta city"
    },
    {
      value: "Kupwara", label: "Kupwara"
    },
    {
      value: "Edapal", label: "Edapal"
    },
    {
      value: "Jhalawar", label: "Jhalawar"
    },
    {
      value: "Kundapur", label: "Kundapur"
    },
    {
      value: "Dausa", label: "Dausa"
    },
    {
      value: "Kotputli", label: "Kotputli"
    },
    {
      value: "Kunnamkulam", label: "Kunnamkulam"
    },
    {
      value: "Mahilpur", label: "Mahilpur"
    },
    {
      value: "Patas", label: "Patas"
    },
    {
      value: "Veraval", label: "Veraval"
    },
    {
      value: "Janjgir-Champa", label: "Janjgir-Champa"
    },
    {
      value: "Manjeri", label: "Manjeri"
    },
    {
      value: "Parbhani", label: "Parbhani"
    },
    {
      value: "Kankavli", label: "Kankavli"
    },
    {
      value: "Behror", label: "Behror"
    },
    {
      value: "Karwar", label: "Karwar"
    },
    {
      value: "Malegaon", label: "Malegaon"
    },
    {
      value: "Canacona", label: "Canacona"
    },
    {
      value: "Rampur", label: "Rampur"
    },
    {
      value: "Pataudi", label: "Pataudi"
    },
    {
      value: "Safidon", label: "Safidon"
    },
    {
      value: "Assandh", label: "Assandh"
    },
    {
      value: "Khliehriat", label: "Khliehriat"
    },
    {
      value: "Rajapalayam", label: "Rajapalayam"
    },
    {
      value: "Kalol", label: "Kalol"
    },
    {
      value: "Jassur", label: "Jassur"
    },
    {
      value: "Taleigao", label: "Taleigao"
    },
    {
      value: "Kathua", label: "Kathua"
    },
    {
      value: "Bankura", label: "Bankura"
    },
    {
      value: "Vadakara", label: "Vadakara"
    },
    {
      value: "Modinagar", label: "Modinagar"
    },
    {
      value: "Mandi dabwali", label: "Mandi dabwali"
    },
    {
      value: "Beawar", label: "Beawar"
    },
    {
      value: "Giridih", label: "Giridih"
    },
    {
      value: "Khopoli", label: "Khopoli"
    },
    {
      value: "Jandiala guru", label: "Jandiala guru"
    },
    {
      value: "Puttur", label: "Puttur"
    },
    {
      value: "Gangavati", label: "Gangavati"
    },
    {
      value: "Vaduj", label: "Vaduj"
    },
    {
      value: "Karaikudi", label: "Karaikudi"
    },
    {
      value: "Narasaraopet", label: "Narasaraopet"
    },
    {
      value: "Kothamangalam", label: "Kothamangalam"
    },
    {
      value: "Budaun", label: "Budaun"
    },
    {
      value: "Mancherial", label: "Mancherial"
    },
    {
      value: "Suri", label: "Suri"
    },
    {
      value: "Lakhimpur Kheri", label: "Lakhimpur Kheri"
    },
    {
      value: "Hansi", label: "Hansi"
    },
    {
      value: "Shrirampur", label: "Shrirampur"
    },
    {
      value: "Indapur", label: "Indapur"
    },
    {
      value: "Kothagudem", label: "Kothagudem"
    },
    {
      value: "Perumbavoor", label: "Perumbavoor"
    },
    {
      value: "Malout", label: "Malout"
    },
    {
      value: "Amreli", label: "Amreli"
    },
    {
      value: "Wadakkanchery", label: "Wadakkanchery"
    },
    {
      value: "Haldia", label: "Haldia"
    },
    {
      value: "Sullia", label: "Sullia"
    },
    {
      value: "Jalalabad", label: "Jalalabad"
    },
    {
      value: "Mundra", label: "Mundra"
    },
    {
      value: "Didwana", label: "Didwana"
    },
    {
      value: "Banda", label: "Banda"
    },
    {
      value: "Jangareddygudem", label: "Jangareddygudem"
    },
    {
      value: "Waluj", label: "Waluj"
    },
    {
      value: "Nurpur", label: "Nurpur"
    },
    {
      value: "Ichalkaranji", label: "Ichalkaranji"
    },
    {
      value: "Charkhi dadri", label: "Charkhi dadri"
    },
    {
      value: "Karad", label: "Karad"
    },
    {
      value: "Vettichira", label: "Vettichira"
    },
    {
      value: "Bavla", label: "Bavla"
    },
    {
      value: "Tiptur", label: "Tiptur"
    },
    {
      value: "Ponda", label: "Ponda"
    },
    {
      value: "Botad", label: "Botad"
    },
    {
      value: "Kottakkal", label: "Kottakkal"
    },
    {
      value: "Sindhanur", label: "Sindhanur"
    },
    {
      value: "Narayangaon", label: "Narayangaon"
    },
    {
      value: "Gondal", label: "Gondal"
    },
    {
      value: "Nirmal", label: "Nirmal"
    },
    {
      value: "Mahoba", label: "Mahoba"
    },
    {
      value: "Chomu", label: "Chomu"
    },
    {
      value: "Patran", label: "Patran"
    },
    {
      value: "Pasighat", label: "Pasighat"
    },
    {
      value: "Alibag", label: "Alibag"
    },
    {
      value: "Ramanattukara", label: "Ramanattukara"
    },
    {
      value: "Chhapra", label: "Chhapra"
    },
    {
      value: "Nagole", label: "Nagole"
    },
    {
      value: "Kanjirappally", label: "Kanjirappally"
    },
    {
      value: "Kokrajhar", label: "Kokrajhar"
    },
    {
      value: "Dhemaji", label: "Dhemaji"
    },
    {
      value: "Nongpoh", label: "Nongpoh"
    },
    {
      value: "Birbhum", label: "Birbhum"
    },
    {
      value: "Madhyamgram", label: "Madhyamgram"
    },
    {
      value: "Chengalpattu", label: "Chengalpattu"
    },
    {
      value: "Palayamkottai", label: "Palayamkottai"
    },
    {
      value: "Tamluk", label: "Tamluk"
    },
    {
      value: "Barasat", label: "Barasat"
    },
    {
      value: "Pehowa", label: "Pehowa"
    },
    {
      value: "Mahad", label: "Mahad"
    },
    {
      value: "Mansa", label: "Mansa"
    },
    {
      value: "Hodal", label: "Hodal"
    },
    {
      value: "Purulia", label: "Purulia"
    },
    {
      value: "Bhawanipatna", label: "Bhawanipatna"
    },
    {
      value: "Lalitpur", label: "Lalitpur"
    },
    {
      value: "Thamarassery", label: "Thamarassery"
    },
    {
      value: "Mannarkkad", label: "Mannarkkad"
    },
    {
      value: "Chikkaballapur", label: "Chikkaballapur"
    },
    {
      value: "Kishangarh", label: "Kishangarh"
    },
    {
      value: "Meham", label: "Meham"
    },
    {
      value: "Saswad", label: "Saswad"
    },
    {
      value: "Sitapur", label: "Sitapur"
    },
    {
      value: "Bijolia", label: "Bijolia"
    },
    {
      value: "Tiruchengode", label: "Tiruchengode"
    },
    {
      value: "Farrukhabad", label: "Farrukhabad"
    },
    {
      value: "Bhadohi", label: "Bhadohi"
    },
    {
      value: "Dahanu", label: "Dahanu"
    },
    {
      value: "Neem-Ka-Thana", label: "Neem-Ka-Thana"
    },
    {
      value: "Fatehnagar", label: "Fatehnagar"
    },
    {
      value: "Sirhind-Fategarh", label: "Sirhind-Fategarh"
    },
    {
      value: "Karjat", label: "Karjat"
    },
    {
      value: "Sirsi", label: "Sirsi"
    },
    {
      value: "Fatehpur", label: "Fatehpur"
    },
    {
      value: "Chirawa", label: "Chirawa"
    },
    {
      value: "Sulur", label: "Sulur"
    },
    {
      value: "Arambag", label: "Arambag"
    },
    {
      value: "Kannauj", label: "Kannauj"
    },
    {
      value: "Nabha", label: "Nabha"
    },
    {
      value: "Bolpur", label: "Bolpur"
    },
    {
      value: "Bangaon", label: "Bangaon"
    },
    {
      value: "Shirur", label: "Shirur"
    },
    {
      value: "Amod", label: "Amod"
    },
    {
      value: "Chengannur", label: "Chengannur"
    },
    {
      value: "Thrithallur", label: "Thrithallur"
    },
    {
      value: "Nathdwara", label: "Nathdwara"
    },
    {
      value: "Doraha", label: "Doraha"
    },
    {
      value: "Brahmapuri", label: "Brahmapuri"
    },
    {
      value: "Palsana", label: "Palsana"
    },
    {
      value: "Kadi", label: "Kadi"
    },
    {
      value: "Barabanki", label: "Barabanki"
    },
    {
      value: "Rayagada", label: "Rayagada"
    },
    {
      value: "Jagadhri", label: "Jagadhri"
    },
    {
      value: "Chinsurah", label: "Chinsurah"
    },
    {
      value: "Jaisalmer", label: "Jaisalmer"
    },
    {
      value: "Chalakudy", label: "Chalakudy"
    },
    {
      value: "Muttom", label: "Muttom"
    },
    {
      value: "Koyilandy", label: "Koyilandy"
    },
    {
      value: "Parassala", label: "Parassala"
    },
    {
      value: "Virar", label: "Virar"
    },
    {
      value: "Nohar", label: "Nohar"
    },
    {
      value: "Biaora", label: "Biaora"
    },
    {
      value: "Shrigonda", label: "Shrigonda"
    },
    {
      value: "Kavali", label: "Kavali"
    },
    {
      value: "Wani", label: "Wani"
    },
    {
      value: "Samastipur", label: "Samastipur"
    },
    {
      value: "Una", label: "Una"
    },
    {
      value: "Machilipatnam", label: "Machilipatnam"
    },
    {
      value: "Bahraich", label: "Bahraich"
    },
    {
      value: "Basirhat", label: "Basirhat"
    },
    {
      value: "Mayiladuthurai", label: "Mayiladuthurai"
    },
    {
      value: "Pandharpur", label: "Pandharpur"
    },
    {
      value: "Karimganj", label: "Karimganj"
    },
    {
      value: "Chikodi", label: "Chikodi"
    },
    {
      value: "Morigaon", label: "Morigaon"
    },
    {
      value: "Chavakkad", label: "Chavakkad"
    },
    {
      value: "Uppinangady", label: "Uppinangady"
    },
    {
      value: "Vaikom", label: "Vaikom"
    },
    {
      value: "Sharif Bihar", label: "Sharif Bihar"
    },
    {
      value: "Nongstoin", label: "Nongstoin"
    },
    {
      value: "Kallambalam", label: "Kallambalam"
    },
    {
      value: "Bodeli", label: "Bodeli"
    },
    {
      value: "Nagoa", label: "Nagoa"
    },
    {
      value: "Papum Pare", label: "Papum Pare"
    },
    {
      value: "Barshi", label: "Barshi"
    },
    {
      value: "Hapur", label: "Hapur"
    },
    {
      value: "Kasganj", label: "Kasganj"
    },
    {
      value: "Katihar", label: "Katihar"
    },
    {
      value: "Mohania", label: "Mohania"
    },
    {
      value: "Rath", label: "Rath"
    },
    {
      value: "Sagwara", label: "Sagwara"
    },
    {
      value: "Sri Muktsar Sahib", label: "Sri Muktsar Sahib"
    },
    {
      value: "Gokak", label: "Gokak"
    },
    {
      value: "Bhadrak", label: "Bhadrak"
    },
    {
      value: "Gajraula", label: "Gajraula"
    },
    {
      value: "Baharagora", label: "Baharagora"
    },
    {
      value: "Uluberia", label: "Uluberia"
    },
    {
      value: "Jowai", label: "Jowai"
    },
    {
      value: "Palus", label: "Palus"
    },
    {
      value: "Bhavani", label: "Bhavani"
    },
    {
      value: "Shikohabad", label: "Shikohabad"
    },
    {
      value: "Unchahar", label: "Unchahar"
    },
    {
      value: "Dhrangadhra", label: "Dhrangadhra"
    },
    {
      value: "Marthandam", label: "Marthandam"
    },
    {
      value: "Sillod", label: "Sillod"
    },
    {
      value: "Omalur", label: "Omalur"
    },
    {
      value: "Kushalanagar", label: "Kushalanagar"
    },
    {
      value: "Madikeri", label: "Madikeri"
    },
    {
      value: "Hindupur", label: "Hindupur"
    },
    {
      value: "Sumerpur", label: "Sumerpur"
    },
    {
      value: "Gumla", label: "Gumla"
    },
    {
      value: "Kotdwara", label: "Kotdwara"
    },
    {
      value: "Rohru", label: "Rohru"
    },
    {
      value: "Deoli", label: "Deoli"
    },
    {
      value: "Uppala", label: "Uppala"
    },
    {
      value: "Sultanpur Lodhi", label: "Sultanpur Lodhi"
    },
    {
      value: "Dharapuram", label: "Dharapuram"
    },
    {
      value: "Hamirpur(UP)", label: "Hamirpur(UP)"
    },
    {
      value: "Bihar Sharif", label: "Bihar Sharif"
    },
    {
      value: "Rampura Phul", label: "Rampura Phul"
    },
    {
      value: "Diglipur", label: "Diglipur"
    },
    {
      value: "Hindaun", label: "Hindaun"
    },
    {
      value: "Jamui", label: "Jamui"
    },
    {
      value: "Dalkhola", label: "Dalkhola"
    },
    {
      value: "Vikarabad", label: "Vikarabad"
    },
    {
      value: "Peddapalli", label: "Peddapalli"
    },
    {
      value: "Sangareddi", label: "Sangareddi"
    },
    {
      value: "Siddipet", label: "Siddipet"
    },
    {
      value: "Zahirabad", label: "Zahirabad"
    },
    {
      value: "Medak District", label: "Medak District"
    },
    {
      value: "Kamareddy", label: "Kamareddy"
    },
    {
      value: "Armoor", label: "Armoor"
    },
    {
      value: "Huzurabad", label: "Huzurabad"
    },
    {
      value: "Hanamkonda", label: "Hanamkonda"
    },
    {
      value: "Mahabubabad", label: "Mahabubabad"
    },
    {
      value: "Parkal", label: "Parkal"
    },
    {
      value: "Jangaon", label: "Jangaon"
    },
    {
      value: "Bhadrachalam", label: "Bhadrachalam"
    },
    {
      value: "Bhuvanagiri", label: "Bhuvanagiri"
    },
    {
      value: "Miryalaguda", label: "Miryalaguda"
    },
    {
      value: "Wanaparthy", label: "Wanaparthy"
    },
    {
      value: "Avanigadda", label: "Avanigadda"
    },
    {
      value: "Tekkali", label: "Tekkali"
    },
    {
      value: "Gadwal", label: "Gadwal"
    },
    {
      value: "Jadcherla", label: "Jadcherla"
    },
    {
      value: "Amalapuram", label: "Amalapuram"
    },
    {
      value: "Kothapeta", label: "Kothapeta"
    },
    {
      value: "Bapatla", label: "Bapatla"
    },
    {
      value: "Tenali", label: "Tenali"
    },
    {
      value: "Razole", label: "Razole"
    },
    {
      value: "Ramachandrapuram", label: "Ramachandrapuram"
    },
    {
      value: "Mandapeta", label: "Mandapeta"
    },
    {
      value: "Dharmavaram", label: "Dharmavaram"
    },
    {
      value: "Repalle", label: "Repalle"
    },
    {
      value: "Sattenapalli", label: "Sattenapalli"
    },
    {
      value: "Samalkota", label: "Samalkota"
    },
    {
      value: "Guntakal", label: "Guntakal"
    },
    {
      value: "Rajampet", label: "Rajampet"
    },
    {
      value: "Mangalagiri", label: "Mangalagiri"
    },
    {
      value: "Chilakaluripet", label: "Chilakaluripet"
    },
    {
      value: "Tadepalligudem", label: "Tadepalligudem"
    },
    {
      value: "Proddatur", label: "Proddatur"
    },
    {
      value: "Kandukur", label: "Kandukur"
    },
    {
      value: "Addanki", label: "Addanki"
    },
    {
      value: "Kanigiri", label: "Kanigiri"
    },
    {
      value: "Attili", label: "Attili"
    },
    {
      value: "Tanuku", label: "Tanuku"
    },
    {
      value: "Palakol", label: "Palakol"
    },
    {
      value: "Chandragiri", label: "Chandragiri"
    },
    {
      value: "Markapur", label: "Markapur"
    },
    {
      value: "Dargamitta", label: "Dargamitta"
    },
    {
      value: "Gudur", label: "Gudur"
    },
    {
      value: "Madanapalle", label: "Madanapalle"
    },
    {
      value: "Palamaner", label: "Palamaner"
    },
    {
      value: "Narsipatnam", label: "Narsipatnam"
    },
    {
      value: "Srikalahasti", label: "Srikalahasti"
    },
    {
      value: "Parvathipuram", label: "Parvathipuram"
    },
    {
      value: "Bobbili", label: "Bobbili"
    },
    {
      value: "Adoni", label: "Adoni"
    },
    {
      value: "Anakapalle", label: "Anakapalle"
    },
    {
      value: "Chodavaram", label: "Chodavaram"
    },
    {
      value: "Nandyal", label: "Nandyal"
    },
    {
      value: "Allagadda", label: "Allagadda"
    },
    {
      value: "Buckinghampet", label: "Buckinghampet"
    },
    {
      value: "Amudalavalasa", label: "Amudalavalasa"
    },
    {
      value: "Ranga reddy", label: "Ranga reddy"
    },
    {
      value: "Madhapur", label: "Madhapur"
    },
    {
      value: "Changlang", label: "Changlang"
    },
    {
      value: "Kurung Kumey", label: "Kurung Kumey"
    },
    {
      value: "Lower Subansiri", label: "Lower Subansiri"
    },
    {
      value: "Tawang", label: "Tawang"
    },
    {
      value: "Tirap", label: "Tirap"
    },
    {
      value: "West Kameng", label: "West Kameng"
    },
    {
      value: "West Siang", label: "West Siang"
    },
    {
      value: "Arunachal Pradesh", label: "Arunachal Pradesh"
    },
    {
      value: "Darrang", label: "Darrang"
    },
    {
      value: "Goalpara", label: "Goalpara"
    },
    {
      value: "Karbi Anglong", label: "Karbi Anglong"
    },
    {
      value: "Nalbari", label: "Nalbari"
    },
    {
      value: "Sonitpur", label: "Sonitpur"
    },
    {
      value: "Nowgong", label: "Nowgong"
    },
    {
      value: "Mangaldai", label: "Mangaldai"
    },
    {
      value: "Anandpur", label: "Anandpur"
    },
    {
      value: "Nalanda", label: "Nalanda"
    },
    {
      value: "Buxar", label: "Buxar"
    },
    {
      value: "Bhojpur", label: "Bhojpur"
    },
    {
      value: "Bettiah", label: "Bettiah"
    },
    {
      value: "Laheriasarai", label: "Laheriasarai"
    },
    {
      value: "Madhubani", label: "Madhubani"
    },
    {
      value: "Aurangabad(bh)", label: "Aurangabad(bh)"
    },
    {
      value: "East Champaran", label: "East Champaran"
    },
    {
      value: "Gopalganj", label: "Gopalganj"
    },
    {
      value: "Lakhisarai", label: "Lakhisarai"
    },
    {
      value: "Madhepura", label: "Madhepura"
    },
    {
      value: "Saran", label: "Saran"
    },
    {
      value: "Sitamarhi", label: "Sitamarhi"
    },
    {
      value: "West Champaran", label: "West Champaran"
    },
    {
      value: "Arwal", label: "Arwal"
    },
    {
      value: "Jehanabad", label: "Jehanabad"
    },
    {
      value: "Dalsingsarai", label: "Dalsingsarai"
    },
    {
      value: "Sheikhpura", label: "Sheikhpura"
    },
    {
      value: "Munger", label: "Munger"
    },
    {
      value: "Banka", label: "Banka"
    },
    {
      value: "Barauni", label: "Barauni"
    },
    {
      value: "Supaul", label: "Supaul"
    },
    {
      value: "Saharsa", label: "Saharsa"
    },
    {
      value: "Bhabua", label: "Bhabua"
    },
    {
      value: "Kudra", label: "Kudra"
    },
    {
      value: "Kochas", label: "Kochas"
    },
    {
      value: "Dehri on sone", label: "Dehri on sone"
    },
    {
      value: "Rohtas", label: "Rohtas"
    },
    {
      value: "Araria", label: "Araria"
    },
    {
      value: "Kishanganj", label: "Kishanganj"
    },
    {
      value: "Barkakana", label: "Barkakana"
    },
    {
      value: "Gobindpur", label: "Gobindpur"
    },
    {
      value: "Marhowrah", label: "Marhowrah"
    },
    {
      value: "Sheohar", label: "Sheohar"
    },
    {
      value: "Vaishali", label: "Vaishali"
    },
    {
      value: "Khambhalia", label: "Khambhalia"
    },
    {
      value: "Union Territory (GJ)", label: "Union Territory (GJ)"
    },
    {
      value: "Bilimora", label: "Bilimora"
    },
    {
      value: "Mandvi (Kachchh)", label: "Mandvi (Kachchh)"
    },
    {
      value: "Sola Housing Board Col", label: "Sola Housing Board Col"
    },
    {
      value: "Kheda", label: "Kheda"
    },
    {
      value: "Panchmahal", label: "Panchmahal"
    },
    {
      value: "Dabhoi", label: "Dabhoi"
    },
    {
      value: "Narmada", label: "Narmada"
    },
    {
      value: "Rajpardi", label: "Rajpardi"
    },
    {
      value: "Kamrej", label: "Kamrej"
    },
    {
      value: "Kachchh", label: "Kachchh"
    },
    {
      value: "Hisar", label: "Hisar"
    },
    {
      value: "Rampur Bushahr", label: "Rampur Bushahr"
    },
    {
      value: "Reckong Peo", label: "Reckong Peo"
    },
    {
      value: "Nahan", label: "Nahan"
    },
    {
      value: "Barsar", label: "Barsar"
    },
    {
      value: "Palampur", label: "Palampur"
    },
    {
      value: "Dharamshala", label: "Dharamshala"
    },
    {
      value: "Hamirpur(hp)", label: "Hamirpur(hp)"
    },
    {
      value: "Jammu Tawi", label: "Jammu Tawi"
    },
    {
      value: "Gandhi Nagar", label: "Gandhi Nagar"
    },
    {
      value: "Budgam", label: "Budgam"
    },
    {
      value: "Doda", label: "Doda"
    },
    {
      value: "Poonch", label: "Poonch"
    },
    {
      value: "Rajauri", label: "Rajauri"
    },
    {
      value: "Bakshi Nagar", label: "Bakshi Nagar"
    },
    {
      value: "Shastri nagar jammu", label: "Shastri nagar jammu"
    },
    {
      value: "Prem Nagar Doda", label: "Prem Nagar Doda"
    },
    {
      value: "Rehari Colony", label: "Rehari Colony"
    },
    {
      value: "Sainik Colony Jammu", label: "Sainik Colony Jammu"
    },
    {
      value: "Channi Himmat", label: "Channi Himmat"
    },
    {
      value: "Janipur", label: "Janipur"
    },
    {
      value: "Bhadarwah", label: "Bhadarwah"
    },
    {
      value: "Residency Road Jammu", label: "Residency Road Jammu"
    },
    {
      value: "New Plot Jammu", label: "New Plot Jammu"
    },
    {
      value: "Bhalwal", label: "Bhalwal"
    },
    {
      value: "Chatra", label: "Chatra"
    },
    {
      value: "East Singhbhum", label: "East Singhbhum"
    },
    {
      value: "Jamtara", label: "Jamtara"
    },
    {
      value: "Koderma", label: "Koderma"
    },
    {
      value: "Latehar", label: "Latehar"
    },
    {
      value: "Sahibganj", label: "Sahibganj"
    },
    {
      value: "Seraikela-kharsawan", label: "Seraikela-kharsawan"
    },
    {
      value: "West Singhbhum", label: "West Singhbhum"
    },
    {
      value: "Simdega", label: "Simdega"
    },
    {
      value: "Baidyanath Deoghar", label: "Baidyanath Deoghar"
    },
    {
      value: "Sindri", label: "Sindri"
    },
    {
      value: "Gomoh", label: "Gomoh"
    },
    {
      value: "Gobindpur (JH)", label: "Gobindpur (JH)"
    },
    {
      value: "Musabani", label: "Musabani"
    },
    {
      value: "Patamda", label: "Patamda"
    },
    {
      value: "Chakulia", label: "Chakulia"
    },
    {
      value: "Ghatsila", label: "Ghatsila"
    },
    {
      value: "Nanjangud", label: "Nanjangud"
    },
    {
      value: "Ranebennuru", label: "Ranebennuru"
    },
    {
      value: "Kumta", label: "Kumta"
    },
    {
      value: "Nargund", label: "Nargund"
    },
    {
      value: "Harpanahalli", label: "Harpanahalli"
    },
    {
      value: "Hampi Power House", label: "Hampi Power House"
    },
    {
      value: "Yadgir", label: "Yadgir"
    },
    {
      value: "Shorapur", label: "Shorapur"
    },
    {
      value: "Shahabad", label: "Shahabad"
    },
    {
      value: "Indi", label: "Indi"
    },
    {
      value: "Jamakhandi", label: "Jamakhandi"
    },
    {
      value: "Tilakwadi", label: "Tilakwadi"
    },
    {
      value: "Bailhongal", label: "Bailhongal"
    },
    {
      value: "Ramdurg", label: "Ramdurg"
    },
    {
      value: "Athni", label: "Athni"
    },
    {
      value: "Hukkeri", label: "Hukkeri"
    },
    {
      value: "Raibag", label: "Raibag"
    },
    {
      value: "Srirangapatna", label: "Srirangapatna"
    },
    {
      value: "Kollegal", label: "Kollegal"
    },
    {
      value: "Channapatna", label: "Channapatna"
    },
    {
      value: "Arsikere", label: "Arsikere"
    },
    {
      value: "Kulshekar", label: "Kulshekar"
    },
    {
      value: "Manipal", label: "Manipal"
    },
    {
      value: "Koppa", label: "Koppa"
    },
    {
      value: "Bhadravathi", label: "Bhadravathi"
    },
    {
      value: "Davangare", label: "Davangare"
    },
    {
      value: "Olavakkode", label: "Olavakkode"
    },
    {
      value: "Alleppy", label: "Alleppy"
    },
    {
      value: "Ottapalam", label: "Ottapalam"
    },
    {
      value: "Ponnani", label: "Ponnani"
    },
    {
      value: "Shertally", label: "Shertally"
    },
    {
      value: "Vatakara", label: "Vatakara"
    },
    {
      value: "Malappuram", label: "Malappuram"
    },
    {
      value: "Thariyode", label: "Thariyode"
    },
    {
      value: "Narasimhapur", label: "Narasimhapur"
    },
    {
      value: "Indore Yeshwant Road", label: "Indore Yeshwant Road"
    },
    {
      value: "Rathlam", label: "Rathlam"
    },
    {
      value: "Lashkar", label: "Lashkar"
    },
    {
      value: "Sawantwadi", label: "Sawantwadi"
    },
    {
      value: "Vengurla", label: "Vengurla"
    },
    {
      value: "Malvan", label: "Malvan"
    },
    {
      value: "Devgadh", label: "Devgadh"
    },
    {
      value: "Bhiwandi", label: "Bhiwandi"
    },
    {
      value: "New Bombay", label: "New Bombay"
    },
    {
      value: "Palghar", label: "Palghar"
    },
    {
      value: "Matheran", label: "Matheran"
    },
    {
      value: "Chalisgaon", label: "Chalisgaon"
    },
    {
      value: "Chinchwad", label: "Chinchwad"
    },
    {
      value: "Bhusawal", label: "Bhusawal"
    },
    {
      value: "Daund", label: "Daund"
    },
    {
      value: "Ahmednagarv", label: "Ahmednagarv"
    },
    {
      value: "Gondia Civil Lines", label: "Gondia Civil Lines"
    },
    {
      value: "Bhandra", label: "Bhandra"
    },
    {
      value: "Buldhana", label: "Buldhana"
    },
    {
      value: "Khamgaon", label: "Khamgaon"
    },
    {
      value: "Paratwada", label: "Paratwada"
    },
    {
      value: "Asegaon", label: "Asegaon"
    },
    {
      value: "Bhayandar", label: "Bhayandar"
    },
    {
      value: "Ahmed Nagar", label: "Ahmed Nagar"
    },
    {
      value: "Gadchiroli", label: "Gadchiroli"
    },
    {
      value: "Raigarh(mh)", label: "Raigarh(mh)"
    },
    {
      value: "Sindhudurg", label: "Sindhudurg"
    },
    {
      value: "Raigad", label: "Raigad"
    },
    {
      value: "Leikai", label: "Leikai"
    },
    {
      value: "Thoubal", label: "Thoubal"
    },
    {
      value: "Aizwal", label: "Aizwal"
    },
    {
      value: "Longleng", label: "Longleng"
    },
    {
      value: "Baleswar", label: "Baleswar"
    },
    {
      value: "Boudh", label: "Boudh"
    },
    {
      value: "Ganjam", label: "Ganjam"
    },
    {
      value: "Kalahandi", label: "Kalahandi"
    },
    {
      value: "Kendrapara", label: "Kendrapara"
    },
    {
      value: "Kendujhar", label: "Kendujhar"
    },
    {
      value: "Khordha", label: "Khordha"
    },
    {
      value: "Nabarangpur", label: "Nabarangpur"
    },
    {
      value: "Puri", label: "Puri"
    },
    {
      value: "Khurda", label: "Khurda"
    },
    {
      value: "CHANDNI CHOWK CUTTACK", label: "CHANDNI CHOWK CUTTACK"
    },
    {
      value: "Athgarh", label: "Athgarh"
    },
    {
      value: "Jagatsinghpur", label: "Jagatsinghpur"
    },
    {
      value: "Jaleswar", label: "Jaleswar"
    },
    {
      value: "Rairangpur", label: "Rairangpur"
    },
    {
      value: "Chhatrapur", label: "Chhatrapur"
    },
    {
      value: "Aska", label: "Aska"
    },
    {
      value: "Bhanjanagar", label: "Bhanjanagar"
    },
    {
      value: "Paralakhemundi", label: "Paralakhemundi"
    },
    {
      value: "Phulbani", label: "Phulbani"
    },
    {
      value: "Tarn Taran", label: "Tarn Taran"
    },
    {
      value: "Gurudaspur", label: "Gurudaspur"
    },
    {
      value: "Bathinda", label: "Bathinda"
    },
    {
      value: "Firozpur", label: "Firozpur"
    },
    {
      value: "Sambhar Lake", label: "Sambhar Lake"
    },
    {
      value: "Nasirabad", label: "Nasirabad"
    },
    {
      value: "Madanganj", label: "Madanganj"
    },
    {
      value: "Marwar", label: "Marwar"
    },
    {
      value: "Mavli", label: "Mavli"
    },
    {
      value: "Kankroli", label: "Kankroli"
    },
    {
      value: "Deeg", label: "Deeg"
    },
    {
      value: "Bayana", label: "Bayana"
    },
    {
      value: "Gangapur Rs", label: "Gangapur Rs"
    },
    {
      value: "Karauli", label: "Karauli"
    },
    {
      value: "Rawatbhata", label: "Rawatbhata"
    },
    {
      value: "Dholpur", label: "Dholpur"
    },
    {
      value: "Ratangarh", label: "Ratangarh"
    },
    {
      value: "Makrana", label: "Makrana"
    },
    {
      value: "Sri Madhopur", label: "Sri Madhopur"
    },
    {
      value: "Jalore", label: "Jalore"
    },
    {
      value: "Sri Ganganagar", label: "Sri Ganganagar"
    },
    {
      value: "Avadi", label: "Avadi"
    },
    {
      value: "Tirukoilur", label: "Tirukoilur"
    },
    {
      value: "Vridhachalam", label: "Vridhachalam"
    },
    {
      value: "Virudhachalam", label: "Virudhachalam"
    },
    {
      value: "Ulundurpet", label: "Ulundurpet"
    },
    {
      value: "Tindivanam", label: "Tindivanam"
    },
    {
      value: "Melur", label: "Melur"
    },
    {
      value: "Aruppukottai", label: "Aruppukottai"
    },
    {
      value: "Srivilliputhur", label: "Srivilliputhur"
    },
    {
      value: "Sirkazhi", label: "Sirkazhi"
    },
    {
      value: "Periyakulam", label: "Periyakulam"
    },
    {
      value: "Melakaveri", label: "Melakaveri"
    },
    {
      value: "Ambasamudram", label: "Ambasamudram"
    },
    {
      value: "Mannargudi", label: "Mannargudi"
    },
    {
      value: "Papanasam", label: "Papanasam"
    },
    {
      value: "Kovilpatti", label: "Kovilpatti"
    },
    {
      value: "Sankarankovil", label: "Sankarankovil"
    },
    {
      value: "Kulithalai", label: "Kulithalai"
    },
    {
      value: "Shrivaikuntam", label: "Shrivaikuntam"
    },
    {
      value: "Srirangam", label: "Srirangam"
    },
    {
      value: "Thuckalay", label: "Thuckalay"
    },
    {
      value: "Parli", label: "Parli"
    },
    {
      value: "Avinashi", label: "Avinashi"
    },
    {
      value: "Lalgudi", label: "Lalgudi"
    },
    {
      value: "Udumalaipettai", label: "Udumalaipettai"
    },
    {
      value: "Kadamparai", label: "Kadamparai"
    },
    {
      value: "Coonoor", label: "Coonoor"
    },
    {
      value: "Kotagiri", label: "Kotagiri"
    },
    {
      value: "Manamadurai", label: "Manamadurai"
    },
    {
      value: "Arakkonam", label: "Arakkonam"
    },
    {
      value: "Alagappapuram", label: "Alagappapuram"
    },
    {
      value: "Devakottai", label: "Devakottai"
    },
    {
      value: "Arni", label: "Arni"
    },
    {
      value: "Ranipet", label: "Ranipet"
    },
    {
      value: "Arcot", label: "Arcot"
    },
    {
      value: "Paramakudi", label: "Paramakudi"
    },
    {
      value: "Tiruppattur", label: "Tiruppattur"
    },
    {
      value: "Sholavandan", label: "Sholavandan"
    },
    {
      value: "Palani", label: "Palani"
    },
    {
      value: "Tallakulam", label: "Tallakulam"
    },
    {
      value: "Arasaradi", label: "Arasaradi"
    },
    {
      value: "Ariyalur", label: "Ariyalur"
    },
    {
      value: "Dhalai", label: "Dhalai"
    },
    {
      value: "North Tripura", label: "North Tripura"
    },
    {
      value: "South Tripura", label: "South Tripura"
    },
    {
      value: "West Tripura", label: "West Tripura"
    },
    {
      value: "Radhakishorepur", label: "Radhakishorepur"
    },
    {
      value: "Etah", label: "Etah"
    },
    {
      value: "Nawabganj", label: "Nawabganj"
    },
    {
      value: "Fatehgarh", label: "Fatehgarh"
    },
    {
      value: "Rasra", label: "Rasra"
    },
    {
      value: "Muzaffar Nagar", label: "Muzaffar Nagar"
    },
    {
      value: "Lalganj", label: "Lalganj"
    },
    {
      value: "Balrampur", label: "Balrampur"
    },
    {
      value: "Bansi", label: "Bansi"
    },
    {
      value: "Zamania", label: "Zamania"
    },
    {
      value: "Ghazipur", label: "Ghazipur"
    },
    {
      value: "Sandila", label: "Sandila"
    },
    {
      value: "Kunraghat", label: "Kunraghat"
    },
    {
      value: "Padrauna", label: "Padrauna"
    },
    {
      value: "Khurja", label: "Khurja"
    },
    {
      value: "Mau Nath Bhanjan", label: "Mau Nath Bhanjan"
    },
    {
      value: "Auraiya", label: "Auraiya"
    },
    {
      value: "Amroha", label: "Amroha"
    },
    {
      value: "Jyotiba Phule Nagar", label: "Jyotiba Phule Nagar"
    },
    {
      value: "Firozabad", label: "Firozabad"
    },
    {
      value: "Chitrakoot", label: "Chitrakoot"
    },
    {
      value: "Gautam Buddha Nagar", label: "Gautam Buddha Nagar"
    },
    {
      value: "Kanpur Dehat", label: "Kanpur Dehat"
    },
    {
      value: "Kanpur Nagar", label: "Kanpur Nagar"
    },
    {
      value: "Kushinagar", label: "Kushinagar"
    },
    {
      value: "Mau", label: "Mau"
    },
    {
      value: "Sant Kabir Nagar", label: "Sant Kabir Nagar"
    },
    {
      value: "Sonbhadra", label: "Sonbhadra"
    },
    {
      value: "Ambedkar Nagar", label: "Ambedkar Nagar"
    },
    {
      value: "Baghpat", label: "Baghpat"
    },
    {
      value: "Lansdowne", label: "Lansdowne"
    },
    {
      value: "Bijnore", label: "Bijnore"
    },
    {
      value: "Dhampur", label: "Dhampur"
    },
    {
      value: "Saharanpur", label: "Saharanpur"
    },
    {
      value: "Shamli", label: "Shamli"
    },
    {
      value: "Pilibhit", label: "Pilibhit"
    },
    {
      value: "Ranikhet", label: "Ranikhet"
    },
    {
      value: "Alipore", label: "Alipore"
    },
    {
      value: "Katwa", label: "Katwa"
    },
    {
      value: "Rampurhat", label: "Rampurhat"
    },
    {
      value: "Balurghat", label: "Balurghat"
    },
    {
      value: "Dhubulia", label: "Dhubulia"
    },
    {
      value: "Ranaghat", label: "Ranaghat"
    },
    {
      value: "Nabadwip", label: "Nabadwip"
    },
    {
      value: "Kandi", label: "Kandi"
    },
    {
      value: "Jalpaiguri", label: "Jalpaiguri"
    },
    {
      value: "Mall", label: "Mall"
    },
    {
      value: "North 24 Parganas", label: "North 24 Parganas"
    },
    {
      value: "South 24 Parganas", label: "South 24 Parganas"
    },
    {
      value: "Darjiling", label: "Darjiling"
    },
    {
      value: "24 Parganas", label: "24 Parganas"
    },
    {
      value: "Puruliya", label: "Puruliya"
    },
    {
      value: "South Dinajpur", label: "South Dinajpur"
    },
    {
      value: "Raghunathganj", label: "Raghunathganj"
    },
    {
      value: "Baruipur", label: "Baruipur"
    },
    {
      value: "Diamond Harbour", label: "Diamond Harbour"
    },
    {
      value: "Kanker", label: "Kanker"
    },
    {
      value: "Banderdewa", label: "Banderdewa"
    },
    {
      value: "Narsapur", label: "Narsapur"
    },
    {
      value: "Suryapet", label: "Suryapet"
    },
    {
      value: "Tuni", label: "Tuni"
    },
    {
      value: "Bihta", label: "Bihta"
    },
    {
      value: "Jashpur", label: "Jashpur"
    },
    {
      value: "Koriya", label: "Koriya"
    },
    {
      value: "Bicholim", label: "Bicholim"
    },
    {
      value: "Margao", label: "Margao"
    },
    {
      value: "Mandgaon", label: "Mandgaon"
    },
    {
      value: "Deesa", label: "Deesa"
    },
    {
      value: "Bansda", label: "Bansda"
    },
    {
      value: "Raebareli", label: "Raebareli"
    },
    {
      value: "Chandauli", label: "Chandauli"
    },
    {
      value: "Shravasti", label: "Shravasti"
    },
    {
      value: "Siddharthnagar", label: "Siddharthnagar"
    },
    {
      value: "Maharajganj", label: "Maharajganj"
    },
    {
      value: "Jalaun", label: "Jalaun"
    },
    {
      value: "Sabarkantha", label: "Sabarkantha"
    },
    {
      value: "Banaskantha", label: "Banaskantha"
    },
    {
      value: "Dang", label: "Dang"
    },
    {
      value: "Vizianagaram", label: "Vizianagaram"
    },
    {
      value: "Kodagu", label: "Kodagu"
    },
    {
      value: "Dharwad", label: "Dharwad"
    },
    {
      value: "Gajapati", label: "Gajapati"
    },
    {
      value: "Kandhamal", label: "Kandhamal"
    },
    {
      value: "Malkangiri", label: "Malkangiri"
    },
    {
      value: "Nuapada", label: "Nuapada"
    },
    {
      value: "Balangir", label: "Balangir"
    },
    {
      value: "Debagarh", label: "Debagarh"
    },
    {
      value: "Cachar", label: "Cachar"
    },
    {
      value: "Dima Hasao", label: "Dima Hasao"
    },
    {
      value: "Hailakandi", label: "Hailakandi"
    },
    {
      value: "East Kameng", label: "East Kameng"
    },
    {
      value: "Upper Siang", label: "Upper Siang"
    },
    {
      value: "East Siang", label: "East Siang"
    },
    {
      value: "Upper Subansiri", label: "Upper Subansiri"
    },
    {
      value: "Lohit", label: "Lohit"
    },
    {
      value: "Dibang Valley", label: "Dibang Valley"
    },
    {
      value: "Lower Dibang Valley", label: "Lower Dibang Valley"
    },
    {
      value: "East Garo Hills", label: "East Garo Hills"
    },
    {
      value: "Serchhip", label: "Serchhip"
    },
    {
      value: "Champhai", label: "Champhai"
    },
    {
      value: "Lawngtlai", label: "Lawngtlai"
    },
    {
      value: "Saiha", label: "Saiha"
    },
    {
      value: "Peren", label: "Peren"
    },
    {
      value: "Kiphire", label: "Kiphire"
    },
    {
      value: "Khagaria", label: "Khagaria"
    },
    {
      value: "Palamu", label: "Palamu"
    },
    {
      value: "Garhwa", label: "Garhwa"
    },
    {
      value: "Fatehgarh Sahib", label: "Fatehgarh Sahib"
    },
    {
      value: "Sirmaur", label: "Sirmaur"
    },
    {
      value: "Kinnaur", label: "Kinnaur"
    },
    {
      value: "Lahaul And Spiti", label: "Lahaul And Spiti"
    },
    {
      value: "Kargil", label: "Kargil"
    },
    {
      value: "Kaushambi", label: "Kaushambi"
    },
    {
      value: "Sant Ravidas Nagar", label: "Sant Ravidas Nagar"
    },
    {
      value: "Kawardha", label: "Kawardha"
    },
    {
      value: "Dantewada", label: "Dantewada"
    },
    {
      value: "Narayanpur", label: "Narayanpur"
    },
    {
      value: "Nilgiris", label: "Nilgiris"
    },
    {
      value: "Manali", label: "Manali"
    },
    {
      value: "Bhanpuri", label: "Bhanpuri"
    },
    {
      value: "Cuncolim", label: "Cuncolim"
    },
    {
      value: "Dharbandora", label: "Dharbandora"
    },
    {
      value: "Barwala", label: "Barwala"
    },
    {
      value: "Devgadh Baria", label: "Devgadh Baria"
    },
    {
      value: "Idar", label: "Idar"
    },
    {
      value: "Jasdan", label: "Jasdan"
    },
    {
      value: "Jetpur", label: "Jetpur"
    },
    {
      value: "Karjan", label: "Karjan"
    },
    {
      value: "Kim", label: "Kim"
    },
    {
      value: "Mahuva", label: "Mahuva"
    },
    {
      value: "Mandal", label: "Mandal"
    },
    {
      value: "Mansa (GJ)", label: "Mansa (GJ)"
    },
    {
      value: "Moti Khavdi", label: "Moti Khavdi"
    },
    {
      value: "Olpad", label: "Olpad"
    },
    {
      value: "Padra", label: "Padra"
    },
    {
      value: "Prantij", label: "Prantij"
    },
    {
      value: "Sayan", label: "Sayan"
    },
    {
      value: "Viramgam", label: "Viramgam"
    },
    {
      value: "Barara", label: "Barara"
    },
    {
      value: "Ellenabad", label: "Ellenabad"
    },
    {
      value: "Ganaur", label: "Ganaur"
    },
    {
      value: "Murthal", label: "Murthal"
    },
    {
      value: "Nuh", label: "Nuh"
    },
    {
      value: "Sampla", label: "Sampla"
    },
    {
      value: "Bandipore", label: "Bandipore"
    },
    {
      value: "Kulgam", label: "Kulgam"
    },
    {
      value: "Sunderbani", label: "Sunderbani"
    },
    {
      value: "Athani", label: "Athani"
    },
    {
      value: "Bangarapet", label: "Bangarapet"
    },
    {
      value: "Bantwal", label: "Bantwal"
    },
    {
      value: "Devanahalli", label: "Devanahalli"
    },
    {
      value: "Kunigal", label: "Kunigal"
    },
    {
      value: "Thokottu", label: "Thokottu"
    },
    {
      value: "Balaramapuram", label: "Balaramapuram"
    },
    {
      value: "Changaramkulam", label: "Changaramkulam"
    },
    {
      value: "Koothattukulam", label: "Koothattukulam"
    },
    {
      value: "Mallappally", label: "Mallappally"
    },
    {
      value: "Paravur", label: "Paravur"
    },
    {
      value: "Urakam", label: "Urakam"
    },
    {
      value: "Barwaha", label: "Barwaha"
    },
    {
      value: "Depalpur", label: "Depalpur"
    },
    {
      value: "Ganj Basoda", label: "Ganj Basoda"
    },
    {
      value: "Kotma", label: "Kotma"
    },
    {
      value: "Maihar", label: "Maihar"
    },
    {
      value: "Mhow", label: "Mhow"
    },
    {
      value: "Sanwer", label: "Sanwer"
    },
    {
      value: "Ankleshwar (MH)", label: "Ankleshwar (MH)"
    },
    {
      value: "Kharghar", label: "Kharghar"
    },
    {
      value: "Ambajogai", label: "Ambajogai"
    },
    {
      value: "Ambegaon", label: "Ambegaon"
    },
    {
      value: "Ballarpur", label: "Ballarpur"
    },
    {
      value: "Dapoli", label: "Dapoli"
    },
    {
      value: "Dindori (MH)", label: "Dindori (MH)"
    },
    {
      value: "Urun Islampur", label: "Urun Islampur"
    },
    {
      value: "Jaysingpur", label: "Jaysingpur"
    },
    {
      value: "Khandala", label: "Khandala"
    },
    {
      value: "Murgud", label: "Murgud"
    },
    {
      value: "Pen", label: "Pen"
    },
    {
      value: "Phaltan", label: "Phaltan"
    },
    {
      value: "Rajapur", label: "Rajapur"
    },
    {
      value: "Warud", label: "Warud"
    },
    {
      value: "Batala", label: "Batala"
    },
    {
      value: "Devigarh", label: "Devigarh"
    },
    {
      value: "Jaitu", label: "Jaitu"
    },
    {
      value: "Mukerian", label: "Mukerian"
    },
    {
      value: "Raikot", label: "Raikot"
    },
    {
      value: "Nihal Singh Wala", label: "Nihal Singh Wala"
    },
    {
      value: "Pohir", label: "Pohir"
    },
    {
      value: "Bagru", label: "Bagru"
    },
    {
      value: "Bassi", label: "Bassi"
    },
    {
      value: "Bhiwadi (RJ)", label: "Bhiwadi (RJ)"
    },
    {
      value: "Neemrana", label: "Neemrana"
    },
    {
      value: "Nokha", label: "Nokha"
    },
    {
      value: "Rajgarh (RJ)", label: "Rajgarh (RJ)"
    },
    {
      value: "Annur", label: "Annur"
    },
    {
      value: "Attur", label: "Attur"
    },
    {
      value: "Harur", label: "Harur"
    },
    {
      value: "Katpadi", label: "Katpadi"
    },
    {
      value: "P.N Palayam", label: "P.N Palayam"
    },
    {
      value: "Valliyur", label: "Valliyur"
    },
    {
      value: "Naugarh", label: "Naugarh"
    },
    {
      value: "Bakshi Ka Talab", label: "Bakshi Ka Talab"
    },
    {
      value: "Chandausi", label: "Chandausi"
    },
    {
      value: "Mahmudabad", label: "Mahmudabad"
    },
    {
      value: "Rishikesh", label: "Rishikesh"
    },
    {
      value: "Srinagar (UK)", label: "Srinagar (UK)"
    },
    {
      value: "Ramnagar", label: "Ramnagar"
    },
    {
      value: "Bishnupur (WB)", label: "Bishnupur (WB)"
    },
    {
      value: "Chandrakona", label: "Chandrakona"
    },
    {
      value: "Ghatal", label: "Ghatal"
    },
    {
      value: "Kalyani", label: "Kalyani"
    },
    {
      value: "Naihati", label: "Naihati"
    },
    {
      value: "Tarakeswar", label: "Tarakeswar"
    },
    {
      value: "Guruvayoor", label: "Guruvayoor"
    },
    {
      value: "Tadipatri", label: "Tadipatri"
    },
    {
      value: "Hilsa", label: "Hilsa"
    },
    {
      value: "Mittapalli", label: "Mittapalli"
    },
    {
      value: "Ganderbal", label: "Ganderbal"
    },
    {
      value: "Beldanga", label: "Beldanga"
    },
    {
      value: "Sonepur", label: "Sonepur"
    },
    {
      value: "Sanchore", label: "Sanchore"
    },
    {
      value: "Patancheru", label: "Patancheru"
    },
    {
      value: "Tenkasi", label: "Tenkasi"
    },
    {
      value: "Alandi", label: "Alandi"
    },
    {
      value: "Manendragarh", label: "Manendragarh"
    },
    {
      value: "Raver", label: "Raver"
    },
    {
      value: "Bilaspur(HP)", label: "Bilaspur(HP)"
    },
    {
      value: "Dadri", label: "Dadri"
    },
    {
      value: "Pratapgarh(RJ)", label: "Pratapgarh(RJ)"
    },
    {
      value: "Narayanpur (CH)", label: "Narayanpur (CH)"
    },
    {
      value: "Bijapur (CH)", label: "Bijapur (CH)"
    },
    {
      value: "Nimbahera", label: "Nimbahera"
    },
    {
      value: "Vita", label: "Vita"
    },
    {
      value: "Phusro", label: "Phusro"
    },
    {
      value: "Vikasnagar", label: "Vikasnagar"
    },
    {
      value: "Tapi", label: "Tapi"
    },
    {
      value: "Shirdi", label: "Shirdi"
    },
    {
      value: "Kuchaman City", label: "Kuchaman City"
    },
    {
      value: "Khunti", label: "Khunti"
    },
    {
      value: "Ankola", label: "Ankola"
    },
    {
      value: "Wai", label: "Wai"
    },
    {
      value: "Kahalgaon", label: "Kahalgaon"
    },
    {
      value: "Rupnarayanpur", label: "Rupnarayanpur"
    },
    {
      value: "Raniganj", label: "Raniganj"
    },
    {
      value: "Metpally", label: "Metpally"
    },
    {
      value: "Thiruttani", label: "Thiruttani"
    },
    {
      value: "Samrala", label: "Samrala"
    },
    {
      value: "Dankuni", label: "Dankuni"
    },
    {
      value: "Vadkhal", label: "Vadkhal"
    },
    {
      value: "Kadapa", label: "Kadapa"
    },
    {
      value: "Gajuwaka", label: "Gajuwaka"
    },
    {
      value: "Islampur (WB)", label: "Islampur (WB)"
    },
    {
      value: "Malbazar", label: "Malbazar"
    },
    {
      value: "Sodawas", label: "Sodawas"
    },
    {
      value: "Phillaur", label: "Phillaur"
    },
    {
      value: "Umbergaon", label: "Umbergaon"
    },
    {
      value: "Dharampur", label: "Dharampur"
    },
    {
      value: "Mayabunder", label: "Mayabunder"
    },
    {
      value: "Sagara", label: "Sagara"
    },
    {
      value: "Udalguri", label: "Udalguri"
    },
    {
      value: "Chirang", label: "Chirang"
    },
    {
      value: "Baksa", label: "Baksa"
    },
    {
      value: "Sivasagar", label: "Sivasagar"
    },
    {
      value: "Lakhimpur(Assam)", label: "Lakhimpur(Assam)"
    },
    {
      value: "Agar Malwa", label: "Agar Malwa"
    },
    {
      value: "Balod", label: "Balod"
    },
    {
      value: "Bemetara", label: "Bemetara"
    },
    {
      value: "Gariaband", label: "Gariaband"
    },
    {
      value: "Kondagaon", label: "Kondagaon"
    },
    {
      value: "Kabirdham", label: "Kabirdham"
    },
    {
      value: "Mungeli", label: "Mungeli"
    },
    {
      value: "Surajpur", label: "Surajpur"
    },
    {
      value: "Sukma", label: "Sukma"
    },
    {
      value: "Ramanujganj", label: "Ramanujganj"
    },
    {
      value: "Balesar", label: "Balesar"
    },
    {
      value: "Shergarh (RJ)", label: "Shergarh (RJ)"
    },
    {
      value: "Phalodi", label: "Phalodi"
    },
    {
      value: "Bhopalgarh", label: "Bhopalgarh"
    },
    {
      value: "Bilara", label: "Bilara"
    },
    {
      value: "Piparcity", label: "Piparcity"
    },
    {
      value: "Osian", label: "Osian"
    },
    {
      value: "Luni", label: "Luni"
    },
    {
      value: "Koratty", label: "Koratty"
    },
    {
      value: "Sathupalli", label: "Sathupalli"
    },
    {
      value: "Jaitaran", label: "Jaitaran"
    },
    {
      value: "Sojat", label: "Sojat"
    },
    {
      value: "Bali", label: "Bali"
    },
    {
      value: "Rani", label: "Rani"
    },
    {
      value: "Falna", label: "Falna"
    },
    {
      value: "Sonepur(OR)", label: "Sonepur(OR)"
    },
    {
      value: "Ambernath", label: "Ambernath"
    },
    {
      value: "Badlapur", label: "Badlapur"
    },
    {
      value: "Shahad", label: "Shahad"
    },
    {
      value: "Poonamallee", label: "Poonamallee"
    },
    {
      value: "Panoor", label: "Panoor"
    },
    {
      value: "Perambra", label: "Perambra"
    },
    {
      value: "Gudalur", label: "Gudalur"
    },
    {
      value: "Sitarganj", label: "Sitarganj"
    },
    {
      value: "Nalagarh", label: "Nalagarh"
    },
    {
      value: "Chakdaha", label: "Chakdaha"
    },
    {
      value: "Mira Road", label: "Mira Road"
    },
    {
      value: "Sultan Bathery", label: "Sultan Bathery"
    },
    {
      value: "Nedumangad", label: "Nedumangad"
    },
    {
      value: "Santiniketan", label: "Santiniketan"
    },
    {
      value: "Thalassery", label: "Thalassery"
    },
    {
      value: "Khatima", label: "Khatima"
    },
    {
      value: "Bijoynagar", label: "Bijoynagar"
    },
    {
      value: "Abu Road", label: "Abu Road"
    },
    {
      value: "Sanand", label: "Sanand"
    },
    {
      value: "Curchorem", label: "Curchorem"
    },
    {
      value: "Dharuhera", label: "Dharuhera"
    },
    {
      value: "Bhadravati", label: "Bhadravati"
    },
    {
      value: "Kangayam", label: "Kangayam"
    },
    {
      value: "Ramganj Mandi", label: "Ramganj Mandi"
    },
    {
      value: "Ambala Cantonment", label: "Ambala Cantonment"
    },
    {
      value: "Amloh", label: "Amloh"
    },
    {
      value: "Nallapadu", label: "Nallapadu"
    },
    {
      value: "Gadarwara", label: "Gadarwara"
    },
    {
      value: "Halol", label: "Halol"
    },
    {
      value: "Itarsi", label: "Itarsi"
    },
    {
      value: "Joda", label: "Joda"
    },
    {
      value: "Kelambakkam", label: "Kelambakkam"
    },
    {
      value: "Konnagar", label: "Konnagar"
    },
    {
      value: "Newai", label: "Newai"
    },
    {
      value: "Naila-Janjgir", label: "Naila-Janjgir"
    },
    {
      value: "Rawatsar", label: "Rawatsar"
    },
    {
      value: "Sachin", label: "Sachin"
    },
    {
      value: "Satana", label: "Satana"
    },
    {
      value: "Shujalpur", label: "Shujalpur"
    },
    {
      value: "Patti", label: "Patti"
    },
    {
      value: "Sarhali", label: "Sarhali"
    },
    {
      value: "Kiraoli", label: "Kiraoli"
    },
    {
      value: "Jobner", label: "Jobner"
    },
    {
      value: "Sarangarh", label: "Sarangarh"
    },
    {
      value: "Alipurduar", label: "Alipurduar"
    },
    {
      value: "Mount Abu", label: "Mount Abu"
    },
    {
      value: "Purba Medinipur", label: "Purba Medinipur"
    },
    {
      value: "Ajitgarh", label: "Ajitgarh"
    },
    {
      value: "Dhuri", label: "Dhuri"
    },
    {
      value: "Kheri", label: "Kheri"
    },
    {
      value: "Kutch", label: "Kutch"
    },
    {
      value: "Midnapore", label: "Midnapore"
    },
    {
      value: "Satyamanglam", label: "Satyamanglam"
    },
    {
      value: "Verna Salcete", label: "Verna Salcete"
    },
    {
      value: "Amethi", label: "Amethi"
    },
    {
      value: "Anakaputhur", label: "Anakaputhur"
    },
    {
      value: "Anandapur", label: "Anandapur"
    },
    {
      value: "Bagaha", label: "Bagaha"
    },
    {
      value: "Bahjoi", label: "Bahjoi"
    },
    {
      value: "Barhalganj", label: "Barhalganj"
    },
    {
      value: "Bhatapara", label: "Bhatapara"
    },
    {
      value: "Byasanagar", label: "Byasanagar"
    },
    {
      value: "Chaibasa", label: "Chaibasa"
    },
    {
      value: "Chakradharpur", label: "Chakradharpur"
    },
    {
      value: "Chintamani", label: "Chintamani"
    },
    {
      value: "Diphu", label: "Diphu"
    },
    {
      value: "Gauriganj", label: "Gauriganj"
    },
    {
      value: "Ghatampur", label: "Ghatampur"
    },
    {
      value: "Harihar", label: "Harihar"
    },
    {
      value: "Jagdishpur", label: "Jagdishpur"
    },
    {
      value: "Jam Jodhpur", label: "Jam Jodhpur"
    },
    {
      value: "Joya", label: "Joya"
    },
    {
      value: "Kadiri", label: "Kadiri"
    },
    {
      value: "Khair", label: "Khair"
    },
    {
      value: "Khalilabad", label: "Khalilabad"
    },
    {
      value: "Khowai", label: "Khowai"
    },
    {
      value: "Konch", label: "Konch"
    },
    {
      value: "Mahisagar", label: "Mahisagar"
    },
    {
      value: "Mewat", label: "Mewat"
    },
    {
      value: "Nakur", label: "Nakur"
    },
    {
      value: "Nowgong", label: "Nowgong"
    },
    {
      value: "Palladam", label: "Palladam"
    },
    {
      value: "Ponneri", label: "Ponneri"
    },
    {
      value: "Rahuri", label: "Rahuri"
    },
    {
      value: "Ramapuram", label: "Ramapuram"
    },
    {
      value: "Rayadurg", label: "Rayadurg"
    },
    {
      value: "Sadabad", label: "Sadabad"
    },
    {
      value: "Sadasivpet", label: "Sadasivpet"
    },
    {
      value: "Sahaswan", label: "Sahaswan"
    },
    {
      value: "Samba", label: "Samba"
    },
    {
      value: "Sambhal", label: "Sambhal"
    },
    {
      value: "Siddapura", label: "Siddapura"
    },
    {
      value: "Sikandrabad", label: "Sikandrabad"
    },
    {
      value: "Soron", label: "Soron"
    },
    {
      value: "Sri Karanpur", label: "Sri Karanpur"
    },
    {
      value: "Tetri Bazar", label: "Tetri Bazar"
    },
    {
      value: "Thiruthuraipoondi", label: "Thiruthuraipoondi"
    },
    {
      value: "Varkala", label: "Varkala"
    },
    {
      value: "Yerraguntla", label: "Yerraguntla"
    },
    {
      value: "New Town", label: "New Town"
    },
    {
      value: "Baddi", label: "Baddi"
    },
    {
      value: "Nagarkurnool", label: "Nagarkurnool"
    },
    {
      value: "Kesarapalle", label: "Kesarapalle"
    },
    {
      value: "Tandur", label: "Tandur"
    },
    {
      value: "Saraipali", label: "Saraipali"
    },
    {
      value: "Ashta", label: "Ashta"
    },
    {
      value: "Pakhanjore", label: "Pakhanjore"
    },
    {
      value: "Kadur", label: "Kadur"
    },
    {
      value: "Ibrahimpatnam", label: "Ibrahimpatnam"
    },
    {
      value: "Alamcode", label: "Alamcode"
    },
    {
      value: "Piravom", label: "Piravom"
    },
    {
      value: "Ahwa", label: "Ahwa"
    },
    {
      value: "Kosamba", label: "Kosamba"
    },
    {
      value: "Talasari", label: "Talasari"
    },
    {
      value: "Khambhat", label: "Khambhat"
    },
    {
      value: "Chikhli", label: "Chikhli"
    },
    {
      value: "Bandikui", label: "Bandikui"
    },
    {
      value: "Kot Kapura", label: "Kot Kapura"
    },
    {
      value: "Hojai", label: "Hojai"
    },
    {
      value: "Biswanath Chariali", label: "Biswanath Chariali"
    },
    {
      value: "Una (Gj)", label: "Una (Gj)"
    },
    {
      value: "Chidambaram", label: "Chidambaram"
    },
    {
      value: "Muradnagar", label: "Muradnagar"
    },
    {
      value: "Ladwa", label: "Ladwa"
    },
    {
      value: "Medchal", label: "Medchal"
    },
    {
      value: "Honnavar", label: "Honnavar"
    },
    {
      value: "Margerita", label: "Margerita"
    },
    {
      value: "Sonari", label: "Sonari"
    },
    {
      value: "Nakhatrana", label: "Nakhatrana"
    },
    {
      value: "Forbesganj", label: "Forbesganj"
    },
    {
      value: "Dudu", label: "Dudu"
    },
    {
      value: "Malerkotla", label: "Malerkotla"
    },
    {
      value: "Sopore", label: "Sopore"
    },
    {
      value: "Iritty", label: "Iritty"
    },
    { value: "Katol", label: "Katol" },
  ];
  const trainStationOptions = [
    { value: "Howrah", label: "Howrah" },
    { value: "Sealdah", label: "Sealdah" },
    { value: "Shalimar", label: "Shalimar" },
    { value: "Kolkata", label: "Kolkata" },
  ];

  let formJson = {
    visitor: [
      "mobile",
      "visitor_name",
      "designation",
      "visiting_as",
      // "invited_company",
      "email",
      "street_add_line1",
      "street_add_line2",
      "city",
      "state",
      "zipcode",
      "country",
      "hduhear",
      "photo",
      "id_front",
      "id_back",
      // "visiting_day",
    ],
    exhibitor_owner: [
      "mobile",
      "visitor_name",
      // "designation",
      // "visiting_as",
      // "invited_company",
      // "email",
      // "street_add_line1",
      // "street_add_line2",
      // "city",
      // "state",
      // "zipcode",
      // "country",
      // "hduhear",
      "photo",
      // "id_front",
      // "id_back",
      // "visiting_day",
    ],
    exhibitor_staff: [
      "mobile",
      "visitor_name",
      // "designation",
      // "visiting_as",
      // "invited_company",
      // "email",
      // "street_add_line1",
      // "street_add_line2",
      // "city",
      // "state",
      // "zipcode",
      // "country",
      // "hduhear",
      "photo",
      // "id_front",
      // "id_back",
      // "visiting_day",
    ],
    exhibitor_modal: [
      "mobile",
      "visitor_name",
      "photo",
      "id_front",
      "id_back",
    ],
    exhibitor_family: [
      "mobile",
      "visitor_name",
      "photo",
      "id_front",
      "id_back",
    ],
    exhibitor_vip: [
      "mobile",
      "visitor_name",
      "designation",
      // "visiting_as",
      // "invited_company",
      "email",
      "street_add_line1",
      "street_add_line2",
      "city",
      "gst_number",
      // "state",
      // "zipcode",
      // "country",
      // "hduhear",
      // "photo",
      // "id_front",
      // "id_back",
      // "visiting_day",
      "company_name",
    ],
    vendor_owner: [
      "mobile",
      "visitor_name",
      // "designation",
      // "visiting_as",
      // "invited_company",
      // "email",
      // "street_add_line1",
      // "street_add_line2",
      // "city",
      // "state",
      // "zipcode",
      // "country",
      // "hduhear",
      "photo",
      "id_front",
      "id_back",
      // "visiting_day",
    ],
    edit_update: [
      "visitor_name",
      "mobile",
      "invited_company",
      "email",
      "photo",
      "id_front",
      "id_back",
    ],
    edit_form_update: [
      "visitor_name",
      "mobile",
      "invited_company",
      "email",
      "photo",
      "id_front",
      "id_back",
    ],
    vendor_staff: [
      "mobile",
      "visitor_name",
      // "designation",
      // "visiting_as",
      // "invited_company",
      // "email",
      // "street_add_line1",
      // "street_add_line2",
      // "city",
      // "state",
      // "zipcode",
      // "country",
      // "hduhear",
      "photo",
      "id_front",
      "id_back",
      // "visiting_day",
    ],
  };
  async function handlePhoto(e) {
    const file = e.target.files[0];
    if (file) {
      let dataStatus = FormatChecker(file);
      setPhotoStatus(dataStatus);
      if (!dataStatus) {
        setPhoto(await compressImage(file));
        setPhotoPreview(URL.createObjectURL(file));
      } else {
        message.error("please upload in the given format");
        setPhoto(null);
        setPhotoPreview(null);
      }
    } else {
      setPhoto(null);
      setPhotoPreview(null);
      setPhotoStatus(false);
    }
  }
  const handleName = (e) => {
    const newValue = e.target.value;
    const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
    setVisitorName(alphabetOnlyValue);
  };
  const handleCompanyNameChange = (e) => {
    const newValue = e.target.value;
    const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
    setCompanyName(alphabetOnlyValue);
  };
  const handleStreetAddressChange = (e) => {
    const newValue = e.target.value;
    const alphabetOnlyValue = newValue.replace(/[^A-Za-z0-9 ]/g, "");
    setStreetAddress(alphabetOnlyValue);
  };
  const handleCityChange = (e) => {
    const newValue = e.target.value;
    const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
    setCity(alphabetOnlyValue);
  };
  const handleStateChange = (e) => {
    const newValue = e.target.value;
    const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
    setState(alphabetOnlyValue);
  };
  const handlePostalCodeChange = (e) => {
    const newValue = e.target.value;
    const numericValue = newValue.replace(/\D/g, "");
    setPostalCode(numericValue);
  };
  const handleCountryChange = (e) => {
    const newValue = e.target.value;
    const alphabetOnlyValue = newValue.replace(/[^A-Za-z ]/g, "");
    setCountry(alphabetOnlyValue);
  };

  const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  function checkRegex(input) {
    return regex.test(input);
  }

  function convertToUpperCase(input) {
    return input.replace(/[a-z]/gi, (char) => char.toUpperCase());
  }

  const handleGstNumberChange = (e) => {
    const convertedValue = convertToUpperCase(e.target.value);
    setGst_number(convertedValue);

    if (checkRegex(convertedValue)) {
      setShowError("");
    } else {
      setShowError("Provide Valid GSTIN");
    }
  };

  useEffect(() => {
    if (gst_number === "22AAAAA0000A1Z5") {
      setDemoGstNumber(true);
      return;
    }
    let timeout;
    if (gst_number.length === 15 && checkRegex(gst_number)) {
      // setReloadShow(true);
      // ;
      timeout = setTimeout(() => {
        setGstValidating(true);

        const runStandardGstValidation = () => {
          axios
            .get(
              `${process.env.REACT_APP_API_END_POINT}/check-gst-validation/${gst_number}`,
            )
            .then((resData) => {
              // setReloadShow(false);
              // console.log(
              //   "hello i am here to see the test daeeed",
              //   resData.data.message,
              //   resData.data.data.lgnm,
              //   resData.data.data.pradr.adr
              // );
              // if (resData.data.message === "GSTIN  found.") {
              console.log("gst find or not", resData.data);
              if (resData.data.flag === false) {
                setShowError(resData.data.message);
                setGstValidating(false);
                return;
              }
              setDemoGstNumber(false);
              setShowError("");
              setCompanyName(resData.data.company);
              setStreetAddress(resData.data.address);
              setCity(resData.data.city);
              setPostalCode(resData.data.postalCode);
              setState(resData.data.state);
              setGstValidating(false);
              // }
            })
            .catch(() => {
              setGstValidating(false);
              setShowError("Error validating GST. Please try again.");
            });
        };

        if (formName === "exhibitor_vip") {
          axios
            .post(
              `${process.env.REACT_APP_API_END_POINT}/check-blacklisted-buyer`,
              {
                gst_number: gst_number,
              },
            )
            .then((resBlacklist) => {
              if (resBlacklist.data.status) {
                AntdModal.warning({
                  title: "Important",
                  content:
                    "Please contact the KCE Office for the particular buyer Contact No: 8100370247",
                  centered: true,
                  okText: "OK",
                  okButtonProps: {
                    style: {
                      backgroundColor: "#1890ff",
                      borderColor: "#1890ff",
                      color: "#fff",
                    },
                  },
                });
                setGst_number("");
                setGstValidating(false);
                return;
              }
              runStandardGstValidation();
            })
            .catch((err) => {
              console.error("Blacklist check error:", err);
              runStandardGstValidation();
            });
        } else {
          runStandardGstValidation();
        }
      }, 400);
    }
    return () => clearTimeout(timeout);
  }, [gst_number]);

  // useEffect(() => {
  //   axios
  //     .post(
  //       `${process.env.REACT_APP_API_END_POINT}/visitor-category`,
  //       {
  //         id: visitingID,
  //       },
  //       {
  //         headers: {
  //           token: localStorage.getItem("token"),
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       console.log("get-visitor", res.data.data);
  //       setAllCategory(res.data.data);
  //     });
  // }, []);

  async function handleIDFront(e) {
    const file = e.target.files[0];
    if (file) {
      let dataStatus = FormatChecker(file);
      setIdFrontStatus(dataStatus);
      if (!dataStatus) {
        setIDProofFront(await compressImage(file));
        setIDProofFrontPreview(URL.createObjectURL(file));
      } else {
        message.error("please upload in the given format");
        setIDProofFront(null);
        setIDProofFrontPreview(null);
      }
    } else {
      setIDProofFront(null);
      setIDProofFrontPreview(null);
      setIdFrontStatus(false);
    }
  }
  async function handleIDBack(e) {
    const file = e.target.files[0];
    if (file) {
      let dataStatus = FormatChecker(file);
      setIdBackStatus(dataStatus);
      if (!dataStatus) {
        setIDProofBack(await compressImage(file));
        setIDProofBackPreview(URL.createObjectURL(file));
      } else {
        message.error("please upload in the given format");
        setIDProofBack(null);
        setIDProofBackPreview(null);
      }
    } else {
      setIDProofBack(null);
      setIDProofBackPreview(null);
      setIdBackStatus(false);
    }
  }

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    // Clear error as user types to improve UX
    if (emailError) {
      setEmailError("");
    }
  };

  const handleEmailBlur = (e) => {
    const value = e.target.value;
    const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    if (value && !emailPattern.test(value)) {
      setEmailError("Invalid email format");
    } else {
      setEmailError("");
    }
  };

  useEffect(() => {
    emptyField();
  }, [reload]);

  useEffect(() => {
    if (
      formName === "vendor_owner" ||
      formName === "vendor_staff" ||
      companyType === "vendor"
    ) {
      axios
        .get(`${process.env.REACT_APP_API_END_POINT}/get-vendor-list`)
        .then((res) => {
          // console.log("assasdasaadads", res.data.data);
          setComapnyList(res.data.data);
        });
    } else {
      if (formName !== "vendor_staff" && formName !== "vendor_owner") {
        axios
          .get(`${process.env.REACT_APP_API_END_POINT}/get-exhibitor-list`, {
            headers: {
              token: storage.get("token"),
            },
          })
          .then((res) => {
            // console.log("assasdasaadads", res.data.data);
            setInvitedByCompany(res?.data?.data);
          });
      }
    }
  }, [reload]);

  useEffect(() => {
    const userId = localStorage.getItem("user_id");
    if (formName !== "vendor_staff" && formName !== "vendor_owner") {
      TokenUndefined("exhibitor/login");
    }

    if (formName !== "vendor_staff" && formName !== "vendor_owner") {
      axios
        .post(`${process.env.REACT_APP_API_END_POINT}/get-exhibitor-name`, "", {
          headers: {
            token: storage.get("token"),
          },
        })
        .then((res) => {
          // LoginRedirection(res, "exhibitor/login");
          setExhibitorName(res.data.data);
          setExhibitorId(res.data.exhibitor_id);
        })
        .catch((err) => {
          // LoginRedirection("/superadmin/login");

          // if (formName !== "vendor_staff" || formName !== "vendor_owner") {
          if (err.response?.status === 401) {
            navigate("/exhibitor/login");
            storage.clearNamespace();
            localStorage.removeItem("user_id");
            localStorage.removeItem("type_of_user");
          }
          // }
        });
    }
  }, []);

  const handleNextStep = () => {
    if (currentStep < totalSteps) {
      handleSubmit();
    }
  };

  const handlePrevStep = () => {
    if (currentStep > 1) {
      axios
        .get(
          `${process.env.REACT_APP_API_END_POINT}/check-registration-status/${formName}/${number}/${exhibitorId}`,
        )
        .then((resData) => {
          if (resData.data.status) {
            setVisitorData(resData.data.data);
          }
          setCurrentStep(currentStep - 1);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching updated data:", error);
          setCurrentStep(currentStep - 1);
        });
    }
  };

  const validateStep = () => {
    switch (currentStep) {
      case 1:
        if (!number) {
          message.error("Mobile Number is required");
          return false;
        }
        if (number.length !== 10) {
          message.error("Please Enter 10 Digit Mobile Number");
          return false;
        }
        if (duplicateError) {
          message.error("This mobile number is already registered");
          return false;
        }
        if (!gst_number) {
          message.error("GST Number is required");
          return false;
        }
        if (gst_number.length !== 15) {
          message.error("GST Number must be exactly 15 characters");
          return false;
        }
        if (gstValidating) {
          message.info("Validating GST number, please wait...");
          return false;
        }
        if (showError) {
          message.error(showError);
          return false;
        }
        if (!visitorName) {
          message.error("Name is required");
          return false;
        }
        if (!email) {
          message.error("Email is required");
          return false;
        }
        if (emailError) {
          message.error("Please provide a valid email address");
          return false;
        }
        if (!gender) {
          message.error("Gender is required");
          return false;
        }
        if (!designation) {
          message.error("Designation is required");
          return false;
        }
        if (!streetAddress) {
          message.error("Address is required");
          return false;
        }
        break;
      case 2:
        if (!photo || !idProofFront || !idProofBack) {
          message.error("Please upload all required documents in step 2");
          return false;
        }
        break;
      case 3:
        if (!arrivalMode) {
          message.error("Please select arrival mode");
          return false;
        }

        if (arrivalMode !== "Self") {
          if (!ticketsFor) {
            message.error("Please select tickets for (Arrival/Departure)");
            return false;
          }

          if (!from) {
            message.error("Please select origin location");
            return false;
          }

          if (!to) {
            message.error("Please select destination location");
            return false;
          }

          if (
            (ticketsFor === "arrival" && travelDate < "2026-08-05") ||
            (ticketsFor === "arrival" && travelDate > "2026-08-07")
          ) {
            message.error(
              "Travel date must be between 5th and 7th August 2026",
            );
            return;
          }

          if (
            (ticketsFor === "departure" && travelDate < "2026-08-06") ||
            (ticketsFor === "departure" && travelDate > "2026-08-08")
          ) {
            message.error(
              "Travel date must be between 6th and 8th August 2026",
            );
            return false;
          }
        }

        if (!stayDate || !stayDuration) {
          message.error("Please select stay date and stay duration");
          return false;
        }
        break;
      default:
        return true;
    }
    return true;
  };

  useEffect(() => {
    if (visitorData) {
      setVisitorName(visitorData.visitor_name || "");
      setNumber(visitorData.mobile_number || "");
      setEmail(visitorData.email || "");
      setDesignation(visitorData.designation || "");
      setCompanyName(visitorData.company_name || "");
      setGst_number(visitorData.gst_number || "");
      setStreetAddress(visitorData.street_address || "");
      setCity(visitorData.city || "");
      setState(visitorData.state || "");
      setGender(visitorData.gender || "");
      // For images, if visitorData has a string path, set the main state to that string
      // and the preview state to the full URL for display.
      // If the user uploads a new file, 'photo' will become a File object,
      // and 'photoPreview' will be an object URL.
      if (visitorData.photo && typeof visitorData.photo === "string") {
        setPhoto(visitorData.photo);
        setPhotoPreview(
          `${process.env.REACT_APP_IMAGE_URL}/photo/${visitorData.photo}?v=${moment().unix()}`,
        );
        setPhotoStatus(false);
      } else if (visitorData.photo instanceof File) {
        setPhoto(visitorData.photo);
        setPhotoPreview(URL.createObjectURL(visitorData.photo));
        setPhotoStatus(false);
      } else {
        setPhoto(null);
        setPhotoPreview(null);
      }

      if (
        visitorData.id_proof_front &&
        typeof visitorData.id_proof_front === "string"
      ) {
        setIDProofFront(visitorData.id_proof_front);
        setIDProofFrontPreview(
          `${process.env.REACT_APP_IMAGE_URL}/id_proof/${visitorData.id_proof_front}?v=${moment().unix()}`,
        );
        setIdFrontStatus(false);
      } else if (visitorData.id_proof_front instanceof File) {
        setIDProofFront(visitorData.id_proof_front);
        setIDProofFrontPreview(URL.createObjectURL(visitorData.id_proof_front));
        setIdFrontStatus(false);
      } else {
        setIDProofFront(null);
        setIDProofFrontPreview(null);
      }

      if (
        visitorData.id_proof_back &&
        typeof visitorData.id_proof_back === "string"
      ) {
        setIDProofBack(visitorData.id_proof_back);
        setIDProofBackPreview(
          `${process.env.REACT_APP_IMAGE_URL}/id_proof/${visitorData.id_proof_back}?v=${moment().unix()}`,
        );
        setIdBackStatus(false);
      } else if (visitorData.id_proof_back instanceof File) {
        setIDProofBack(visitorData.id_proof_back);
        setIDProofBackPreview(URL.createObjectURL(visitorData.id_proof_back));
        setIdBackStatus(false);
      } else {
        setIDProofBack(null);
        setIDProofBackPreview(null);
      }

      if (visitorData.travel_info) {
        setArrivalMode(visitorData.travel_info.arrival_mode || "");
        setTicketsFor(visitorData.travel_info.tickets_for || "");
        setFrom(visitorData.travel_info.from || "");
        setTo(visitorData.travel_info.to || "");
        setStayDuration(visitorData.travel_info.stay_duration || "1");
        setStayDate(visitorData.travel_info.stay_date || null);
        const initialNeedsCab =
          visitorData.travel_info.needs_cab !== undefined
            ? visitorData.travel_info.needs_cab
            : visitorData.travel_info.tickets_for === "arrival";
        setNeedsCab(initialNeedsCab);
        setPreferredTravelTime(
          visitorData.travel_info.preferred_travel_time || "",
        );
        setTravelDate(visitorData.travel_info.travel_date || "");
        setRemarksValue(visitorData.remarks_value || "");
      }
    }
  }, [visitorData, currentStep]);

  const handleSubmit = async (e, paymentWasJustMade = false) => {
    if (e) {
      e.preventDefault();
    }
    setIsLoading(true);

    const effectivePaymentStatus = paymentWasJustMade || isPaymentTaken;

    if (formName === "exhibitor_vip") {
      if (!validateStep()) {
        setIsLoading(false);
        return;
      }

      try {
        const formData = new FormData();
        formData.append("mobile_number", number);
        formData.append("category", formName);
        formData.append("currentStep", currentStep.toString());
        formData.append("exhibitor_id", exhibitorId);
        if (isEditing) {
          formData.append("isEditing", "true");
          formData.append("barcodeId", barcodeId);
        }

        if (currentStep === 1) {
          formData.append("visitor_name", visitorName);
          formData.append("email", email);
          formData.append("designation", designation);
          formData.append("company_name", companyName);
          formData.append("gst_number", gst_number);
          formData.append("street_address", streetAddress);
          formData.append("city", city);
          formData.append("state", state);
          formData.append("gender", gender);
          formData.append("postal_code", postalCode);
        } else if (currentStep === 2) {
          formData.append("photo", photo);
          formData.append("id_proof_front", idProofFront);
          formData.append("id_proof_back", idProofBack);
        } else if (currentStep === 3) {
          formData.append("arrival_mode", arrivalMode);
          if (arrivalMode !== "Self") {
            formData.append("tickets_for", ticketsFor || "");
            formData.append("from", from || "");
            formData.append("to", to || "");
            formData.append("preferred_travel_time", preferredTravelTime || "");
            formData.append(
              "needs_cab",
              needsCab === null || needsCab === undefined
                ? ticketsFor === "arrival"
                  ? true
                  : false
                : needsCab,
            );
            formData.append("travel_date", travelDate);
          }
          formData.append("stay_duration", stayDuration);
          formData.append("stay_date", stayDate);
          formData.append("remarks_value", remarksValue || "");
        }

        const response = await axios.post(
          `${process.env.REACT_APP_API_END_POINT}/add-visitor`,
          formData,
          {
            headers: {
              token: storage.get("token"),
            },
          },
        );

        if (
          response.data.message ===
            "Number already registered for another exhibitor" &&
          response.data.status == false
        ) {
          message.error(response.data.message);
          setIsLoading(false);
          return;
        }
        if (response.data.status == false) {
          message.error(response.data.message);
          setIsLoading(false);
          return;
        }

        if (response.data.messageData) {
          message.error(response.data.messageData);
          return;
        }

        if (currentStep < totalSteps) {
          message.success(`Step ${currentStep} completed successfully!`);
          setVisitorData(response.data.data);
          setCurrentStep(currentStep + 1);
        } else {
          message.success("Registration completed successfully!");
          navigate("/exhibitor/vip-guest-requrest-list");
        }

        return;
      } catch (error) {
        console.error("Error submitting form:", error);
        message.error("An error occurred. Please try again.");
        setIsLoading(false);
        return;
      } finally {
        setIsLoading(false);
      }
    }

    // form submission code for other categories
    const dataNeedTOCheck = await axios.get(
      `${process.env.REACT_APP_API_END_POINT}/form-status-exhibitor`,
      {
        headers: {
          token: storage.get("token"),
        },
      },
    );
    if (formName === "exhibitor_owner" && !dataNeedTOCheck.data.ownerstatus) {
      message.error("The limit to add new members has exhausted");
      setIsLoading(false);

      return;
    }

    if (
      formName === "exhibitor_staff" &&
      !dataNeedTOCheck.data.staffstatus &&
      !effectivePaymentStatus
    ) {
      if (extraStaffRegistration === "inactive") {
        message.error(
          "Limit of adding staff is exhausted please contact administration for support",
        );
        setIsLoading(false);
        return;
      }
      setShowExtraOwnerModal(true);
      setIsLoading(false);
      return;
    }
    if (formName === "exhibitor_vip" && !dataNeedTOCheck.data.vipstatus) {
      message.error("The limit to add new members has exhausted");
      setIsLoading(false);

      return;
    }

    //  formName !== "exhibitor_staff" &&
    // formName !== "exhibitor_vip"
    //  .then((res) => {
    //    console.log(res.data);
    //    if (res.data.staffstatus) {
    //      navigate("/exhibitor/exhibitor-staff-registration");
    //    } else {
    //      message.error("The limit to add new members has exhausted");
    //    }
    //  });

    if (!visitorName) {
      message.error("Name is required");
      setIsLoading(false);
    } else if (!number) {
      message.error("Phone Number is required");
      setIsLoading(false);
    } else if (number.length !== 10) {
      message.error("Please Enter 10 Digit Mobile Number");
      setIsLoading(false);
      return;
    } else if (duplicateError) {
      message.error("Mobile number already exists");
      setIsLoading(false);
      return;
    } else if (emailError && formName !== "exhibitor_vip") {
      message.error("Invalid email format");
      setIsLoading(false);
      return;
    } else if (!companyName && formName === "exhibitor_vip") {
      message.error("Company Name is required");
      setIsLoading(false);
    } else if (!designation && formName === "exhibitor_vip") {
      message.error("Designation is required");
      setIsLoading(false);
    } else if (!city && formName === "exhibitor_vip") {
      message.error("City is required");
      setIsLoading(false);
    } else if (!country && formName === "exhibitor_vip") {
      message.error("Country is required");
      setIsLoading(false);
    } else if (!gst_number && formName === "exhibitor_vip") {
      message.error("Fill Valid Gst Number");
      setIsLoading(false);
    } else if (!photo && formName !== "exhibitor_vip" && formName !== "exhibitor_modal") {
      message.error("Photo is required");
      setIsLoading(false);
    } else if (
      !idProofFront &&
      formName !== "exhibitor_owner" &&
      formName !== "exhibitor_staff" &&
      formName !== "exhibitor_vip"
    ) {
      message.error("ID Proof Front is required");
      setIsLoading(false);
    } else if (
      !idProofBack &&
      formName !== "exhibitor_owner" &&
      formName !== "exhibitor_staff" &&
      formName !== "exhibitor_vip"
    ) {
      message.error("ID Proof Back is required");
      setIsLoading(false);
    } else {
      if (editStatus) {
        // if (number.length !== 10) {
        //   message.error("Please Enter 10 Digit Mobile Number");
        //   setIsLoading(false);
        //   return;
        // }
        // if (emailError) {
        //   message.error("Invalid email format");
        //   setIsLoading(false);
        //   return;
        // }
        e.preventDefault();
        const formData = new FormData();
        formData.append("visitor_name", visitorName);
        formData.append("email", email);
        formData.append("company_name", companyName);
        formData.append("mobile_number", number);
        formData.append("invited_exhibitor_id", invitedByCompany);
        formData.append("photo", photo);
        formData.append("id_proof_front", idProofFront);
        formData.append("id_proof_back", idProofBack);
        formData.append("id", id);

        axios
          .post(
            `${process.env.REACT_APP_API_END_POINT}/update-visitor`,
            formData,
            {
              headers: {
                ...(storage.get("token") && { token: storage.get("token") }),
                barcode,
              },
            },
          )
          .then((res) => {
            if (res.data.messageData) {
              message.error(res.data.messageData);
              setIsLoading(false);
              emptyField();
            } else {
              window.location.reload(true);
              // setReload(!reload)
              // message.success("Form Submit Successfully");
              window.alert("Form Submit Successfully");
              setIsLoading(false);
            }
          })
          .catch((error) => {
            console.error("Axios Error:", error);
          });
      } else {
        // {
        if (!photo && !idProofFront && !idProofBack) {
          axios
            .post(
              `${process.env.REACT_APP_API_END_POINT}/add-visitor`,
              {
                mobile_number: number,
                visitor_name: visitorName,
                designation: designation,
                visiting_as: visiting_as,
                firm_id: yourCompany,
                invited_exhibitor_id: invitedByCompany,
                email: email,
                company_name: companyName,
                street_address: streetAddress,
                street_address_two: streetAddressTwo,
                city: city,
                gst_number,
                state: state,
                postal_code: postalCode,
                country: country,
                hear_about_jff: hearAbout,
                category: formName,
                visiting_day: visitingDay,
                visitor_category_id: visitingID,
                barcodeId,
              },
              {
                headers: {
                  ...(storage.get("token") && { token: storage.get("token") }),
                },
              },
            )
            .then((res) => {
              // setReload(!reload)
              // window.location.reload(true);
              // message.success("Form Submit Successfully");
              if (res.data.messageData) {
                message.error(res.data.messageData);
                setIsLoading(false);
                emptyField();
              } else {
                window.alert("Form Submit Successfully");
                setIsLoading(false);
                window.location.reload(true);
                if (formName === "exhibitor_owner") {
                  // console.log("anisdsdif", formName);
                  navigate("/exhibitor/owner-list");
                } else if (formName === "exhibitor_staff") {
                  // console.log("anisdsdif", formName);
                  navigate("/exhibitor/staff-list");
                } else if (formName === "exhibitor_modal") {
                  navigate("/exhibitor/modal-list");
                } else if (formName === "exhibitor_family") {
                  navigate("/exhibitor/family-list");
                } else if (formName === "exhibitor_vip") {
                  // console.log("anisdsdif", formName);
                  navigate("/exhibitor/vip-guest-requrest-list");
                }
              }
            })
            .catch((err) => {
              // LoginRedirection("/superadmin/login");
              setIsLoading(false);
              if (err.response?.status === 401) {
                navigate("/superadmin/login");
                storage.clearNamespace();
                localStorage.removeItem("user_id");
                localStorage.removeItem("type_of_user");
              }
            });
        } else {
          const formData = new FormData();
          formData.append("mobile_number", number);
          formData.append("visitor_name", visitorName);
          formData.append("designation", designation);
          formData.append("visiting_as", visiting_as);
          formData.append("firm_id", yourCompany);
          formData.append("invited_exhibitor_id", invitedByCompany);
          formData.append("email", email);
          formData.append("company_name", companyName);
          formData.append("street_address", streetAddress);
          formData.append("street_address_two", streetAddressTwo);
          formData.append("city", city);
          formData.append("state", state);
          formData.append("postal_code", postalCode);
          formData.append("country", country);
          formData.append("hear_about_jff", hearAbout);
          formData.append("photo", photo);
          formData.append("id_proof_front", idProofFront);
          formData.append("id_proof_back", idProofBack);
          formData.append("category", formName);
          formData.append("visiting_day", visitingDay);
          formData.append("visitor_category_id", visitingID);
          formData.append("barcodeId", barcodeId);
          if (effectivePaymentStatus && formName === "exhibitor_staff") {
            formData.append("additional_staff_member", true);
          }
          axios
            .post(
              `${process.env.REACT_APP_API_END_POINT}/add-visitor`,
              formData,
              {
                headers: {
                  ...(storage.get("token") && { token: storage.get("token") }),
                },
              },
            )
            .then(async (res) => {
              // setReload(!reload)
              // window.location.reload(true);
              // message.success("Form Submit Successfully");
              if (res.data.messageData) {
                message.error(res.data.messageData);
                setIsLoading(false);
                return;
              }
              if (res.data.status === false) {
                message.error(res.data.message);
                setIsLoading(false);
                return;
              }
              if (formName === "exhibitor_modal") {
                const modelBarcode = res.data.message?.barcode || res.data.data?.barcode || res.data.barcode;
                const modelName = res.data.message?.visitor_name || res.data.data?.visitor_name || visitorName;
                const modelMobile = res.data.message?.mobile_number || res.data.data?.mobile_number || number;

                const loadScript = (src) => {
                  return new Promise((resolve) => {
                    const script = document.createElement("script");
                    script.src = src;
                    script.onload = () => resolve(true);
                    script.onerror = () => resolve(false);
                    document.body.appendChild(script);
                  });
                };

                const launchModelRazorpay = async () => {
                  const loaded = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
                  if (!loaded) {
                    message.error("Razorpay SDK failed to load. Complete payment from Model List.");
                    setIsLoading(false);
                    emptyField();
                    navigate("/exhibitor/modal-list");
                    return;
                  }

                  const TEST_NUMBERS = ["9784319991", "7352620486", "7737450029"];
                  const isOneRupee =
                    TEST_NUMBERS.includes(modelMobile?.toString().trim()) ||
                    res.data?.payment_amount === 1 ||
                    res.data?.order?.amount === 100;
                  const rzpAmount = res.data?.order?.amount || (isOneRupee ? 100 : 118000);
                  const feeDescription = rzpAmount === 100
                    ? "Model Registration Fee (₹1/-)"
                    : "Model Registration Fee (₹1,180/-)";

                  const options = {
                    key: process.env.REACT_APP_RAZORPAY_API_KEY || "rzp_test_SrwLOXEF8tH1ph",
                    amount: rzpAmount,
                    currency: "INR",
                    name: "KCE Exhibitor Console",
                    description: feeDescription,
                    notes: { barcode: modelBarcode, category: "exhibitor_modal" },
                    handler: function (response) {
                      message.loading("Verifying payment...", 1);
                      axios
                        .post(
                          `${process.env.REACT_APP_API_END_POINT}/models/verify-payment`,
                          {
                            barcode: modelBarcode,
                            payment_id: response.razorpay_payment_id,
                            order_id: response.razorpay_order_id,
                          },
                          {
                            headers: { token: storage.get("token") },
                          }
                        )
                        .then(() => {
                          message.success("Payment verified & model registered successfully!");
                        })
                        .catch((err) => {
                          console.error("Payment verification error:", err);
                          message.success("Model registered!");
                        })
                        .finally(() => {
                          setIsLoading(false);
                          emptyField();
                          navigate("/exhibitor/modal-list");
                        });
                    },
                    modal: {
                      ondismiss: function () {
                        message.warning("Payment cancelled. Complete payment anytime from Model List.");
                        setIsLoading(false);
                        emptyField();
                        navigate("/exhibitor/modal-list");
                      },
                    },
                    prefill: {
                      name: modelName,
                      contact: modelMobile,
                    },
                    theme: {
                      color: "#d47d78",
                    },
                  };

                  const paymentObject = new window.Razorpay(options);
                  paymentObject.open();
                };

                launchModelRazorpay();
                return;
              }

              emptyField();
              if (
                res.data.message &&
                res.data.message.extra_staff_member == "false"
              ) {
                const onPaymentSuccess = () => {
                  setIsLoading(false);
                  emptyField();
                  message.success(res.data.message);
                  window.location.reload(true);
                  setIsLoading(false);
                };

                const staffAmount = [
                  "9461069357",
                  "7352620486",
                  "7737450029",
                ].includes(res.data.message.mobile_number)
                  ? 1
                  : process.env.REACT_APP_EXTRA_STAFF_REGISTRATION_AMOUNT ||
                    1180;
                await createRazorypayOrder(
                  staffAmount,
                  res.data.message.barcode,
                  res.data.message.mobile_number || "0000000000",
                  res.data.message.email || "test@gmail.com",
                  res.data.message.visitor_name || "test",
                  onPaymentSuccess,
                );
              } else {
                window.alert("Form Submit Successfully");
                setIsLoading(false);
                window.location.reload(true);
                // console.log("anisdsd", formName);
                if (formName === "exhibitor_owner") {
                  // console.log("anisdsdif", formName);
                  navigate("/exhibitor/owner-list");
                } else if (formName === "exhibitor_staff") {
                  // console.log("anisdsdif", formName);
                  navigate("/exhibitor/staff-list");
                } else if (formName === "exhibitor_modal") {
                  navigate("/exhibitor/modal-list");
                } else if (formName === "exhibitor_family") {
                  navigate("/exhibitor/family-list");
                } else if (formName === "exhibitor_vip") {
                  // console.log("anisdsdif", formName);
                  navigate("/exhibitor/vip-guest-requrest-list");
                }
              }
            })
            .catch((err) => {
              // LoginRedirection("/superadmin/login");
              setIsLoading(false);
              if (err.response?.status === 401) {
                navigate("/superadmin/login");
                storage.clearNamespace();
                localStorage.removeItem("user_id");
                localStorage.removeItem("type_of_user");
              }
            });
        }
        // }
      }
    }
  };
  const emptyField = () => {
    setGst_number("");
    setVisitorName("");
    setNumber("");
    setEmail("");
    setCompanyName("");
    setDesignation("");
    setYourCompany("");
    setVisiting_as("");
    setStreetAddress("");
    setstreetAddressTwo("");
    setCity("");
    setState("");
    setPostalCode("");
    // setCountrsy("");
    setHearAbout("");
    setPhoto("");
    setIDProofFront(null);
    setIDProofBack("");
    setInvitedByCompany("");
    setVisitingCategory("");
    setVisitingID("");
    setInvitedCompanyName("");
    setVisitingDay("");
    setStayDuration("");
    setStayDate(null);
    setPreferredTravelTime("");
    setIsPaymentTaken(false);
  };

  // Add step content components
  const renderStep1 = () => (
    <div>
      <h5 className="mb-4">Step 1: Basic Information</h5>
      <Row>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Mobile Number <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              placeholder="Mobile No."
              value={number}
              maxLength={10}
              onChange={handleMobileNoChange}
            />
            {duplicateError && (
              <Form.Text className="text-danger" style={{ fontSize: "10px" }}>
                This number is already registered
              </Form.Text>
            )}
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              GST Number <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              value={gst_number}
              maxLength={15}
              placeholder="GST Number"
              onChange={handleGstNumberChange}
            />
            {showError && (
              <Form.Text className="text-danger">{showError}</Form.Text>
            )}
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              placeholder="Name"
              value={visitorName}
              maxLength={100}
              onChange={handleName}
            />
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">Company Name</Form.Label>
            <Form.Control
              value={companyName}
              maxLength={40}
              placeholder="Company Name"
              onChange={handleCompanyNameChange}
              readOnly={!demoGstNumber}
            />
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Email <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              placeholder="Email"
              value={email}
              onChange={handleEmailChange}
              onBlur={handleEmailBlur}
            />
            {emailError && (
              <Form.Text className="text-danger">{emailError}</Form.Text>
            )}
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Gender <span className="text-danger">*</span>
            </Form.Label>
            <Select
              isDisabled={isApproved}
              options={[
                { value: "Male", label: "Male" },
                { value: "Female", label: "Female" },
              ]}
              value={gender ? { value: gender, label: gender } : null}
              onChange={(selectedOption) => {
                const newGender = selectedOption ? selectedOption.value : null;
                setGender(newGender);
              }}
              isSearchable
              placeholder="Select gender"
              required={true}
            />
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Designation <span className="text-danger">*</span>
            </Form.Label>
            <Select
              isDisabled={isApproved}
              options={designationArray.map((data) => ({
                value: data,
                label: data,
              }))}
              value={
                designation ? { value: designation, label: designation } : null
              }
              onChange={(selectedOption) =>
                setDesignation(selectedOption ? selectedOption.value : null)
              }
              isSearchable
              placeholder="Select designation"
            />
          </Form.Group>
        </Col>

        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Address <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              placeholder="Address"
              value={streetAddress}
              maxLength={150}
              onChange={handleStreetAddressChange}
              readOnly={!demoGstNumber}
            />
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">Pin Code</Form.Label>
            <Form.Control
              placeholder="Pin Code"
              value={postalCode}
              maxLength={100}
              onChange={handlePostalCodeChange}
              readOnly={!demoGstNumber}
            />
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">City</Form.Label>
            <Form.Control
              placeholder="City"
              value={city}
              maxLength={100}
              onChange={handleCityChange}
              readOnly={!demoGstNumber}
            />
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">State</Form.Label>
            <Form.Control
              placeholder="State"
              value={state}
              maxLength={100}
              onChange={handleStateChange}
              readOnly={!demoGstNumber}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );

  const renderStep2 = () => (
    <div>
      <h5 className="mb-4">Step 2: Document Upload</h5>
      <Row>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Upload Photo <span className="text-danger">*</span>
              {photoStatus && (
                <Form.Text className="text-danger d-block">
                  Only supported (JPG/JPEG/PNG)
                </Form.Text>
              )}
            </Form.Label>
            <Form.Control
              type="file"
              onChange={handlePhoto}
              accept=".jpg, .jpeg, .png"
            />
            {photoPreview ? (
              <div className="mt-2">
                <img
                  loading="lazy"
                  src={photoPreview}
                  alt="User"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                  }}
                />
              </div>
            ) : photo ? (
              <div className="mt-2">
                <img
                  src={`${process.env.REACT_APP_IMAGE_URL}/photo/${photo}?v=${moment().unix()}`}
                  alt="User"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                  }}
                />
              </div>
            ) : (
              <span>-</span>
            )}
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Aadhaar Card (Front) <span className="text-danger">*</span>
              {idFrontStatus && (
                <Form.Text className="text-danger d-block">
                  Only supported (JPG/JPEG/PNG)
                </Form.Text>
              )}
            </Form.Label>
            <Form.Control
              type="file"
              onChange={handleIDFront}
              accept=".jpg, .jpeg, .png"
            />
            {idProofFrontPreview ? (
              <div className="mt-2">
                <img
                  src={idProofFrontPreview}
                  alt="Preview"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                  }}
                />
              </div>
            ) : idProofFront ? (
              <div className="mt-2">
                <img
                  src={`${process.env.REACT_APP_IMAGE_URL}/id_proof/${idProofFront}?v=${moment().unix()}`}
                  alt="ID Front"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                  }}
                />
              </div>
            ) : (
              <span>-</span>
            )}
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Aadhaar Card (Back) <span className="text-danger">*</span>
              {idBackStatus && (
                <Form.Text className="text-danger d-block">
                  Only supported (JPG/JPEG/PNG)
                </Form.Text>
              )}
            </Form.Label>
            <Form.Control
              type="file"
              onChange={handleIDBack}
              accept=".jpg, .jpeg, .png"
            />
            {idProofBackPreview ? (
              <div className="mt-2">
                <img
                  src={idProofBackPreview}
                  alt="Preview"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                  }}
                />
              </div>
            ) : idProofBack ? (
              <div className="mt-2">
                <img
                  className="img-size"
                  src={`${process.env.REACT_APP_IMAGE_URL}/id_proof/${idProofBack}?v=${moment().unix()}`}
                  alt="ID Front"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                  }}
                />
              </div>
            ) : (
              <span>-</span>
            )}
          </Form.Group>
        </Col>
      </Row>
    </div>
  );

  const renderStep3 = () => (
    <div>
      <h5 className="mb-4">Step 3: Travel Information</h5>
      <Row>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Travel Mode <span className="text-danger">*</span>
            </Form.Label>
            <Select
              isDisabled={isApproved}
              options={travelModes}
              value={
                arrivalMode ? { value: arrivalMode, label: arrivalMode } : null
              }
              onChange={(selectedOption) => {
                setArrivalMode(selectedOption ? selectedOption.value : null);
                setTravelDate("");
              }}
              isSearchable
              placeholder="Select arrival mode"
              required={true}
            />
          </Form.Group>
        </Col>
        {arrivalMode !== "Self" && (
          <Col lg={6} md={6} className="mb-3">
            <Form.Group>
              <Form.Label className="fw-bold">
                Tickets for (Arrival/Departure){" "}
                <span className="text-danger">*</span>
              </Form.Label>
              <Select
                isDisabled={isApproved}
                options={[
                  { value: "arrival", label: "Arrival" },
                  { value: "departure", label: "Departure" },
                ]}
                value={
                  ticketsFor
                    ? {
                        value: ticketsFor,
                        label:
                          ticketsFor.charAt(0).toUpperCase() +
                          ticketsFor.slice(1),
                      }
                    : null
                }
                onChange={(selectedOption) => {
                  const newTicketsFor = selectedOption
                    ? selectedOption.value
                    : null;
                  setTicketsFor(newTicketsFor);
                  setTravelDate("");

                  if (newTicketsFor === "arrival" && arrivalMode !== "Self") {
                    setTo("Kolkata");
                    setNeedsCab(true);
                  } else if (
                    newTicketsFor === "departure" &&
                    arrivalMode !== "Self"
                  ) {
                    setFrom("Kolkata");
                    setNeedsCab(false);
                  }
                }}
                isSearchable
                placeholder="Select tickets for"
                required={true}
              />
            </Form.Group>
          </Col>
        )}
        {arrivalMode !== "Self" && (
          <Col lg={6} md={6} className="mb-3">
            <Form.Group>
              <Form.Label className="fw-bold">
                From <span className="text-danger">*</span>
              </Form.Label>
              {ticketsFor === "arrival" &&
              (arrivalMode === "Flight" || arrivalMode === "Train") ? (
                <Select
                  isDisabled={isApproved}
                  options={
                    arrivalMode === "Flight" ? flightOptions : trainOptions
                  }
                  value={(arrivalMode === "Flight"
                    ? flightOptions
                    : trainOptions
                  ).find((option) => option.value === from)}
                  onChange={(selectedOption) => {
                    setFrom(selectedOption ? selectedOption.value : null);
                    setTravelDate("");
                  }}
                  isSearchable
                  placeholder={`Select ${arrivalMode === "Flight" ? "origin airport" : "origin station"}`}
                  required={true}
                />
              ) : ticketsFor === "departure" && arrivalMode === "Train" ? (
                <Select
                  isDisabled={isApproved}
                  options={trainStationOptions}
                  value={trainStationOptions.find(
                    (option) => option.value === from,
                  )}
                  onChange={(selectedOption) => {
                    setFrom(selectedOption ? selectedOption.value : null);
                    setTo("");
                    setTravelDate("");
                  }}
                  isSearchable
                  placeholder="Select origin station"
                  required={true}
                />
              ) : (
                <Form.Control
                  placeholder="From"
                  value={from}
                  maxLength={100}
                  onChange={(e) => {
                    setFrom(e.target.value);
                    setTo("");
                    setTravelDate("");
                  }}
                  required={true}
                  readOnly={
                    ticketsFor === "departure" || arrivalMode === "Self"
                  }
                />
              )}
            </Form.Group>
          </Col>
        )}
        {arrivalMode !== "Self" && (
          <Col lg={6} md={6} className="mb-3">
            <Form.Group>
              <Form.Label className="fw-bold">
                To <span className="text-danger">*</span>
              </Form.Label>
              {ticketsFor === "departure" &&
              (arrivalMode === "Flight" || arrivalMode === "Train") ? (
                <Select
                  isDisabled={isApproved}
                  options={
                    arrivalMode === "Flight" ? flightOptions : trainOptions
                  }
                  value={(arrivalMode === "Flight"
                    ? flightOptions
                    : trainOptions
                  ).find((option) => option.value === to)}
                  onChange={(selectedOption) => {
                    setTo(selectedOption ? selectedOption.value : null);
                    setTravelDate("");
                  }}
                  isSearchable
                  placeholder={`Select ${arrivalMode === "Flight" ? "destination airport" : "destination station"}`}
                  required={true}
                />
              ) : ticketsFor === "arrival" && arrivalMode === "Train" ? (
                <Select
                  isDisabled={isApproved}
                  options={trainStationOptions}
                  value={trainStationOptions.find(
                    (option) => option.value === to,
                  )}
                  onChange={(selectedOption) => {
                    setTo(selectedOption ? selectedOption.value : null);
                    setFrom("");
                    setTravelDate("");
                  }}
                  isSearchable
                  placeholder="Select destination station"
                  required={true}
                />
              ) : (
                <Form.Control
                  placeholder="To"
                  value={to}
                  maxLength={100}
                  onChange={(e) => {
                    setTo(e.target.value);
                    setFrom("");
                    setTravelDate("");
                  }}
                  required={true}
                  readOnly={ticketsFor === "arrival" || arrivalMode === "Self"}
                />
              )}
            </Form.Group>
          </Col>
        )}

        {arrivalMode !== "Self" && (
          <Col lg={6} md={6} className="mb-3">
            <Form.Group>
              <Form.Label className="fw-bold">
                Preferred Travel Time <span className="text-danger">*</span>
              </Form.Label>
              <Select
                isDisabled={isApproved}
                options={travelTimeOptions}
                value={
                  preferredTravelTime
                    ? { value: preferredTravelTime, label: preferredTravelTime }
                    : null
                }
                onChange={(selectedOption) =>
                  setPreferredTravelTime(
                    selectedOption ? selectedOption.value : null,
                  )
                }
                isSearchable
                placeholder="Select preferred travel time"
                required={true}
              />
            </Form.Group>
          </Col>
        )}
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Stay Duration <span className="text-danger">*</span>
            </Form.Label>
            <Select
              isDisabled={isApproved}
              options={[
                { value: "1", label: "1 Night" },
                { value: "2", label: "2 Nights" },
              ]}
              value={
                stayDuration
                  ? {
                      value: stayDuration,
                      label: `${stayDuration} Night${stayDuration === "2" ? "s" : ""}`,
                    }
                  : null
              }
              onChange={(selectedOption) => {
                setStayDuration(selectedOption ? selectedOption.value : null);
                setStayDate("");
              }}
              isSearchable
              placeholder="Select stay duration"
              required={true}
            />
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Stay Date <span className="text-danger">*</span>
            </Form.Label>
            <Select
              isDisabled={isApproved}
              options={stayDuration === "1" ? oneNightOptions : twoNightOptions}
              value={stayDate ? { value: stayDate, label: stayDate } : null}
              onChange={(selectedOption) =>
                setStayDate(selectedOption ? selectedOption.value : null)
              }
              isSearchable
              placeholder="Select stay date"
              required={true}
            />
          </Form.Group>
        </Col>
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">
              Travel Date <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="date"
              value={travelDate}
              onChange={(e) => setTravelDate(e.target.value)}
              required
              min={ticketsFor === "arrival" ? "2026-08-05" : "2026-08-06"}
              max={ticketsFor === "arrival" ? "2026-08-07" : "2026-08-08"}
            />
          </Form.Group>
        </Col>

        {arrivalMode !== "Self" && travelDate !== "2026-08-08" && (
          <Col lg={6} md={6} className="mb-3">
            <Form.Group>
              <Form.Label className="fw-bold">
                Need cab facility? <span className="text-danger">*</span>
              </Form.Label>
              <div className="d-flex gap-3">
                <Form.Check
                  type="radio"
                  id="needsCabYes"
                  label="Yes"
                  checked={needsCab === true}
                  onChange={() => setNeedsCab(true)}
                />
                <Form.Check
                  type="radio"
                  id="needsCabNo"
                  label="No"
                  checked={needsCab === false}
                  onChange={() => setNeedsCab(false)}
                />
              </div>
            </Form.Group>
          </Col>
        )}
        <Col lg={6} md={6} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">Remarks (Optional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={remarksValue}
              onChange={(e) => setRemarksValue(e.target.value)}
              placeholder="Enter any additional notes or remarks"
            />
          </Form.Group>
        </Col>
      </Row>
      <ul className="mt-2">
        <li className="">
          <small className="text-danger">
            We will be providing one-way tickets.
          </small>
        </li>
        <li>
          <small className="text-danger">
            Hotel stay will be a maximum of two nights.
          </small>
        </li>
      </ul>
    </div>
  );

  return (
    <>
      <section>
        <div className="container">
          <div className="text-center">
            <h4 className="form-heading">{formHeader}</h4>
          </div>
          {isEditing && (
            <div
              className="form-body d-flex align-items-center mb-3 mt-3"
              style={{
                border: "none",
                boxShadow: "none",
                padding: 0,
                backgroundColor: "transparent",
              }}
            >
              <FaAngleDoubleLeft
                className="pointer-cursor me-2"
                onClick={() => {
                  if (formName === "exhibitor_vip") {
                    navigate("/exhibitor/vip-guest-requrest-list");
                  } else {
                    navigate(-1);
                  }
                }}
              />
              <span
                className="pointer-cursor"
                onClick={() => {
                  if (formName === "exhibitor_vip") {
                    navigate("/exhibitor/vip-guest-requrest-list");
                  } else {
                    navigate(-1);
                  }
                }}
              >
                Back
              </span>
            </div>
          )}
          <div className="form-body-section">
            <div className="form-body">
              {errorMessage ? (
                <div
                  className="alert alert-danger text-center p-4 my-3"
                  role="alert"
                  style={{ borderRadius: "8px" }}
                >
                  <h5 className="alert-heading fw-bold mb-2">Access Denied</h5>
                  <p className="mb-0">{errorMessage}</p>
                </div>
              ) : isApproved ? (
                <div
                  className="alert alert-success text-center p-4 my-3"
                  role="alert"
                  style={{ borderRadius: "8px" }}
                >
                  <h5 className="alert-heading fw-bold mb-2">
                    Approved & Locked
                  </h5>
                  <p className="mb-0">
                    This buyer is already approved, so their details cannot be
                    edited.
                  </p>
                </div>
              ) : (
                <>
                  {formName === "exhibitor_vip" ? (
                    <>
                      {currentStep === 1 && renderStep1()}
                      {currentStep === 2 && renderStep2()}
                      {currentStep === 3 && renderStep3()}
                    </>
                  ) : (
                    <div>
                      {formJson[formName]?.includes("mobile") && (
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextMobile"
                        >
                          <Form.Label column sm="4">
                            Mobile No.<span className="text-danger">*</span>
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              type="text"
                              required
                              value={number}
                              onChange={handleMobileNoChange}
                              maxLength={10}
                              placeholder="Enter 10 digit Mobile Number"
                            />
                            {duplicateError && (
                              <span style={{ color: "red" }}>
                                Mobile number already exist
                              </span>
                            )}
                          </Col>
                        </Form.Group>
                      )}
                      {formJson[formName]?.includes("visitor_name") && (
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextVisitorName"
                        >
                          <Form.Label column sm="4">
                            Name<span className="text-danger">*</span>
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              type="text"
                              required
                              placeholder="Name"
                              value={visitorName}
                              maxLength={100}
                              onChange={handleName}
                            />
                          </Col>
                        </Form.Group>
                      )}
                      {formJson[formName]?.includes("photo") && (
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPhoto"
                        >
                          <Form.Label column sm="4">
                            Upload Photo<span className="text-danger">*</span>
                            {photoStatus && (
                              <Form.Text className="text-danger d-block ms-2">
                                {" "}
                                {/* ms-2 for slight indent */}
                                Only supported (JPG/JPEG/PNG)
                              </Form.Text>
                            )}
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              type="file"
                              required
                              onChange={handlePhoto}
                              accept=".jpg, .jpeg, .png"
                            />
                            {photoPreview && (
                              <div className="mt-2">
                                <img
                                  loading="lazy"
                                  src={photoPreview}
                                  alt="Photo Preview"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                            )}
                          </Col>
                        </Form.Group>
                      )}
                      {formJson[formName]?.includes("id_front") && (
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextIdFront"
                        >
                          <Form.Label column sm="4">
                            ID Proof (Front)<span className="text-danger">*</span>
                            {idFrontStatus && (
                              <Form.Text className="text-danger d-block ms-2">
                                Only supported (JPG/JPEG/PNG)
                              </Form.Text>
                            )}
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              type="file"
                              required
                              onChange={handleIDFront}
                              accept=".jpg, .jpeg, .png"
                            />
                            {idProofFrontPreview && (
                              <div className="mt-2">
                                <img
                                  loading="lazy"
                                  src={idProofFrontPreview}
                                  alt="ID Front Preview"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                            )}
                          </Col>
                        </Form.Group>
                      )}
                      {formJson[formName]?.includes("id_back") && (
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextIdBack"
                        >
                          <Form.Label column sm="4">
                            ID Proof (Back)<span className="text-danger">*</span>
                            {idBackStatus && (
                              <Form.Text className="text-danger d-block ms-2">
                                Only supported (JPG/JPEG/PNG)
                              </Form.Text>
                            )}
                          </Form.Label>
                          <Col sm="8">
                            <Form.Control
                              type="file"
                              required
                              onChange={handleIDBack}
                              accept=".jpg, .jpeg, .png"
                            />
                            {idProofBackPreview && (
                              <div className="mt-2">
                                <img
                                  loading="lazy"
                                  src={idProofBackPreview}
                                  alt="ID Back Preview"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                            )}
                          </Col>
                        </Form.Group>
                      )}
                    </div>
                  )}

                  {formName === "exhibitor_vip" && (
                    <div className={`form-submit d-flex mt-4 ${currentStep === 1
                          ? "justify-content-end"
                          : "justify-content-between"
                      }`}>
                      {currentStep > 1 && (
                        <Button
                          onClick={handlePrevStep}
                          variant="outline-secondary"
                          disabled={isLoading}
                        >
                          Previous
                        </Button>
                      )}
                      {currentStep < totalSteps ? (
                        <Button
                          onClick={handleNextStep}
                          variant="outline-primary"
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            "Next"
                          )}
                        </Button>
                      ) : (
                        <Button
                          onClick={handleSubmit}
                          variant="outline-primary"
                          disabled={isLoading || duplicateError}
                        >
                          {isLoading ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            "Submit"
                          )}
                        </Button>
                      )}
                    </div>
                  )}

                  {formName !== "exhibitor_vip" && (
                    <div className="form-submit d-flex justify-content-end mt-4">
                      <Button
                        onClick={handleSubmit}
                        variant="outline-primary"
                        disabled={isLoading || duplicateError}
                      >
                        {isLoading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          "Submit"
                        )}
                      </Button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <Modal
        centered
        show={showExtraOwnerModal}
        onHide={() => setShowExtraOwnerModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Limit Exceeded</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>The limit to add new members has exhausted</p>
          <p>
            If you want to add more members, You need to Pay Rs{" "}
            {["9461069357", "7352620486", "7737450029"].includes(number)
              ? 1
              : process.env.REACT_APP_EXTRA_STAFF_REGISTRATION_AMOUNT || 1180}
            /- per Member
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-dark"
            onClick={() => {
              setShowExtraOwnerModal(false);
              handleSubmit(null, true);
            }}
          >
            Pay Now
          </Button>
          <Button
            variant="outline-danger"
            onClick={() => setShowExtraOwnerModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default VisitorForm;
